(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nw-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwAboutHeroInit) return;
  window.__nwAboutHeroInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.15 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-abouthero[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-aporta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwAportaInit) return;
  window.__nwAportaInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); }
        });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }
  }

  function boot() { document.querySelectorAll('.nw-aporta[data-nw-reveal-root]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  /* El Theme Editor re-monta la sección al editarla: sin esto se queda invisible. */
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwArticleInit) return;
  window.__nwArticleInit = true;

  function init(root) {
    if (!root || root.dataset.nwReady) return;
    root.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('[data-reveal]');

    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
    /* Salvaguarda: si algo falla, el contenido nunca queda invisible */
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 1200);
  }

  function boot() { document.querySelectorAll('[data-nw-article]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-b2b"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwB2bInit) return;
  window.__nwB2bInit = true;

  function initRoot(root) {
    if (!root || root.dataset.nwReady) return;
    root.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { root.classList.add('is-in'); io.unobserve(root); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      io.observe(root);
    } else {
      root.classList.add('is-in');
    }
  }

  function boot() {
    document.querySelectorAll('[data-nw-b2b] [data-nw-reveal-root]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwBlogInit) return;
  window.__nwBlogInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) { sec.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
    }, { threshold: 0.06 });
    io.observe(sec);
  }
  function boot() { document.querySelectorAll('[data-nw-blog]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-ciencia"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwCienciaInit) return;
  window.__nwCienciaInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Cifras FIJAS (500/150/60): ya vienen en el HTML; no hay count-up. El JS solo revela
       la entrada (fade). Si el JS no carga, el fallback <noscript> deja todo visible. */
    function run() { sec.classList.add('is-in'); }
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { run(); io.unobserve(sec); } });
      }, { threshold: 0.25 });
      io.observe(sec);
    } else { run(); }
  }
  function boot() { document.querySelectorAll('.nw-ciencia[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-club"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwClubInit) return;
  window.__nwClubInit = true;

  function initReveal(sec, reduced) {
    var els = sec.querySelectorAll('[data-reveal]');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMarquee(sec, reduced) {
    var vp = sec.querySelector('[data-nw-viewport]');
    var track = sec.querySelector('[data-nw-track]');
    if (!vp || !track) return;
    if (reduced) return; /* scroll-x nativo, sin auto-scroll */

    var paused = false, hidden = false;
    vp.addEventListener('mouseenter', function () { paused = true; });
    vp.addEventListener('mouseleave', function () { paused = false; });
    vp.addEventListener('focusin', function () { paused = true; });
    vp.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { hidden = document.hidden; });

    var mobile = window.matchMedia('(max-width: 767px)');
    function speed() { return mobile.matches ? 42 : 34; } /* px/s */
    function gapPx() {
      var cs = getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }
    var gap = gapPx();
    window.addEventListener('resize', function () { gap = gapPx(); });

    var offset = 0, prev = null;
    function frame(t) {
      if (prev === null) prev = t;
      var dt = t - prev; prev = t;
      if (!paused && !hidden && dt > 0 && dt < 100) {
        offset -= speed() * dt / 1000;
        var first = track.firstElementChild;
        var guard = 0;
        while (first && guard < 60) {
          var fw = first.offsetWidth + gap;
          if (fw > 0 && -offset >= fw) {
            offset += fw;
            track.appendChild(first);
            first = track.firstElementChild;
            guard++;
          } else { break; }
        }
        track.style.transform = 'translate3d(' + offset.toFixed(2) + 'px,0,0)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    initReveal(sec, reduced);
    initMarquee(sec, reduced);
  }

  function boot() { document.querySelectorAll('[data-nw-club]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-como-tomarlo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwDialInit) return;
  window.__nwDialInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Vídeo diferido y ligero (~1,8 MB): se carga en desktop Y móvil, pero SOLO al entrar en
       viewport (IntersectionObserver) con el póster mientras tanto — así no pesa en el load inicial.
       Si el usuario tiene el modo ahorro de datos activo, se queda solo el póster. */
    var ctVid = sec.querySelector('[data-nw-ct-video]');
    var ctSaveData = navigator.connection && navigator.connection.saveData;
    if (ctVid && !reduced && !ctSaveData) {
      var ctLoad = function () {
        if (ctVid.src) return;
        ctVid.src = ctVid.getAttribute('data-src'); ctVid.load();
        var pr = ctVid.play(); if (pr && pr.catch) pr.catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { ctLoad(); vio.disconnect(); } });
        }, { rootMargin: '300px 0px' });
        vio.observe(sec);
      } else { ctLoad(); }
    }

    var steps = Array.prototype.slice.call(sec.querySelectorAll('.nw-comotomarlo__step'));
    var dotsWrap = sec.querySelector('[data-nw-dial-dots]');
    if (!steps.length) return;
    var n = steps.length, idx = 0, timer = null;

    steps.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'nw-comotomarlo__dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Paso ' + (i + 1));
      d.addEventListener('click', function () { show(i); restart(); });
      dotsWrap.appendChild(d);
    });
    var dots = dotsWrap.querySelectorAll('.nw-comotomarlo__dot');

    // Click en un paso: salta a ese paso y reinicia el temporizador (control manual).
    // NO usamos hover para cambiar de paso: al centrar el paso, la rueda se reordena y el
    // paso se movía bajo el cursor, disparando mouseenter en cadena ("se volvía loco").
    // El único hover que actúa es sobre el DIAL (círculo pequeño): SOLO pausa la rotación
    // para poder leer, sin reordenar nada.
    steps.forEach(function (s, i) {
      s.addEventListener('click', function () { show(i); restart(); });
    });
    var dialEl = sec.querySelector('.nw-comotomarlo__dial');
    if (dialEl) {
      dialEl.addEventListener('mouseenter', stop);
      dialEl.addEventListener('mouseleave', start);
    }

    // Coloca el paso ACTIVO en el centro (amarillo), el anterior arriba y el siguiente
    // abajo (atenuados) mediante flex `order`; pasos lejanos ocultos (para n > 3).
    // Orden natural fijo (1 arriba, 2, 3 abajo); solo se mueve el resaltado amarillo de
    // arriba a abajo, sin reordenar la rueda.
    function show(i) {
      idx = ((i % n) + n) % n;
      steps.forEach(function (s, j) {
        s.style.order = '';
        s.style.display = '';
        s.classList.toggle('is-active', j === idx);
      });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
    }
    function tick() { show(idx + 1); }
    function start() { if (!reduced && !timer && n > 1) timer = setInterval(tick, 2500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    show(0);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); start(); }
          else stop();
        });
      }, { threshold: 0.3 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); start(); }
  }
  function boot() { document.querySelectorAll('.nw-comotomarlo[data-nw-dial]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-cta-club"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwCtaClubInit) return;
  window.__nwCtaClubInit = true;

  function splitWords(el) {
    if (!el || el.dataset.split) return;
    el.dataset.split = '1';
    // "|" fuerza salto de línea (cada tramo = una .nw-cta-club__line en bloque)
    var lines = el.textContent.trim().split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    el.textContent = '';
    var wi = 0;
    lines.forEach(function (lineText, li) {
      var lineEl = document.createElement('span');
      lineEl.className = 'nw-cta-club__line';
      var words = lineText.split(/\s+/);
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'nw-cta-club__word';
        span.style.setProperty('--w', wi++);
        span.textContent = w;
        lineEl.appendChild(span);
        if (i < words.length - 1) lineEl.appendChild(document.createTextNode(' '));
      });
      el.appendChild(lineEl);
      if (li < lines.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    splitWords(sec.querySelector('[data-nw-words]'));
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); }
        });
      }, { threshold: 0.2 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }
  }
  function boot() { document.querySelectorAll('[data-nw-reveal-root].nw-cta-club').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-cuando-como"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwCuandoComoInit) return;
  window.__nwCuandoComoInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); }
        });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }
  }

  function boot() { document.querySelectorAll('.nw-cuandocomo[data-nw-reveal-root]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-datos-estudio-b"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwDatosBInit) return;
  window.__nwDatosBInit = true;

  function animateCount(el, reduced) {
    var raw = el.getAttribute('data-count');
    if (raw === null) return;
    /* Solo se anima si es un número limpio. Cualquier otra cosa (texto, rangos)
       se deja tal cual: es un setting libre y no debe romperse. */
    var target = parseFloat(String(raw).replace(',', '.'));
    if (!isFinite(target)) return;
    var decs = (String(raw).split(/[.,]/)[1] || '').length;
    var sep = String(raw).indexOf(',') > -1;
    function paint(v) {
      var s = decs ? v.toFixed(decs) : String(Math.round(v));
      el.textContent = sep ? s.replace('.', ',') : s;
    }
    if (reduced) { paint(target); return; }
    var dur = 1400, t0 = null;
    paint(0);
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      /* easeOutExpo, a juego con --nw-ease */
      var e = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      paint(target * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nums = Array.prototype.slice.call(sec.querySelectorAll('[data-count]'));

    function run() {
      sec.classList.add('is-in');
      nums.forEach(function (n, i) {
        /* Escalonado a juego con los data-stagger del CSS */
        setTimeout(function () { animateCount(n, reduced); }, reduced ? 0 : 260 + i * 150);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { run(); io.unobserve(sec); }
        });
      }, { threshold: 0.22 });
      io.observe(sec);
    } else {
      run();
    }

    /* Parallax de la foto, en la capa propia (nunca en un ancestro del glass:
       un transform ahí apagaría el backdrop-filter de los discos). */
    var img = sec.querySelector('.nw-datos-b__img');
    if (img && !reduced) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var r = sec.getBoundingClientRect(), vh = window.innerHeight;
          if (r.bottom > 0 && r.top < vh) {
            var p = (r.top + r.height / 2 - vh / 2) / vh;
            img.style.transform = 'translateY(' + (p * -3.5) + '%)';
          }
          ticking = false;
        });
      }, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('.nw-datos-b[data-nw-datos-b]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-datos-estudio"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwDatosInit) return;
  window.__nwDatosInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Cifras, anillos y barras FIJOS: ya vienen resueltos en el HTML/CSS; el JS solo revela
       la entrada (fade). Si el JS no carga, el fallback <noscript> deja todo visible. */
    function run() { sec.classList.add('is-in'); }
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { run(); }

    /* Slider móvil: dots + flecha lateral. La flecha pasa a la siguiente columna y se oculta al final. */
    var slider = sec.querySelector('[data-nw-datos-slider]');
    var swipe = sec.querySelector('[data-nw-datos-swipe]');
    var chev = sec.querySelector('[data-nw-datos-chev]');
    if (slider) {
      var dots = swipe ? Array.prototype.slice.call(swipe.querySelectorAll('[data-nw-datos-dot]')) : [];
      var cards = Array.prototype.slice.call(slider.querySelectorAll('.nw-datos__card'));
      var ticking = false;
      function goto(i) {
        var c = cards[i]; if (!c) return;
        slider.scrollTo({ left: c.offsetLeft - slider.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
      function activeIdx() {
        var mid = slider.scrollLeft + slider.clientWidth / 2, best = 0, bd = Infinity;
        cards.forEach(function (c, i) {
          var cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - mid);
          if (d < bd) { bd = d; best = i; }
        });
        return best;
      }
      function sync() {
        ticking = false;
        var a = activeIdx();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
        if (chev) chev.hidden = (a >= cards.length - 1);
      }
      slider.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(sync); }
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goto(i); }); });
      if (chev) chev.addEventListener('click', function () { goto(activeIdx() + 1); });
      sync();
    }
  }
  function boot() { document.querySelectorAll('.nw-datos[data-nw-datos]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-esto-es-para-ti"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwEeptInit) return;
  window.__nwEeptInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    if (reduced) return;
    var layers = sec.querySelectorAll('[data-nw-layer]');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom > 0 && r.top < vh) {
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          layers.forEach(function (l) {
            var k = parseFloat(l.getAttribute('data-nw-layer')) || 0.1;
            var base = l.className.indexOf('--duo') !== -1 ? 'translate(-50%, -50%) ' : '';
            l.style.transform = base + 'translateY(' + (p * k * 100) + 'px)';
          });
        }
        ticking = false;
      });
    }, { passive: true });
  }
  function boot() { document.querySelectorAll('.nw-eept[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-evidencia"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwEvidenciaInit) return;
  window.__nwEvidenciaInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); }
        });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }
  }

  function boot() { document.querySelectorAll('.nw-evidencia[data-nw-reveal-root]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwFaqInit) return;
  window.__nwFaqInit = true;
  /* Respuesta propia de un sabor (29-oct-2026, Raw): la ficha (nw-lp2) emite `nw:flavor` con el handle del sabor
     elegido; se enseña la respuesta de ese sabor si la hay y, si no, la de siempre. */
  document.addEventListener('nw:flavor', function (e) {
    var h = e && e.detail && e.detail.handle;
    if (!h) return;
    document.querySelectorAll('.nw-faq [data-nw-faq-flv]').forEach(function (alt) {
      var on = alt.getAttribute('data-nw-faq-flv') === h, def = alt.previousElementSibling;
      alt.hidden = !on;
      if (def && def.hasAttribute('data-nw-faq-def')) def.hidden = on;
    });
  });
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.15 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-faq[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwFooterInit) return;
  window.__nwFooterInit = true;

  function init(footer) {
    if (!footer || footer.dataset.nwReady) return;
    footer.dataset.nwReady = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            footer.classList.add('is-in');
            io.unobserve(footer);
          }
        });
      }, { threshold: 0.12 });
      io.observe(footer);
    } else {
      footer.classList.add('is-in');
    }

    /* parallax sutil del watermark */
    var mark = footer.querySelector('[data-nw-mark] svg');
    if (mark && !reduced) {
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = footer.getBoundingClientRect();
          var vh = window.innerHeight;
          if (rect.top < vh && rect.bottom > 0) {
            var progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
            mark.style.transform = 'translateY(' + ((1 - progress) * 40) + 'px)';
          }
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot() {
    document.querySelectorAll('[data-nw-footer]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwHeaderInit) return;
  window.__nwHeaderInit = true;

  function init(header) {
    if (!header || header.dataset.nwReady) return;
    header.dataset.nwReady = '1';

    var burger = header.querySelector('[data-nw-burger]');
    var root = header.closest('.shopify-section') || document;
    var panel = root.querySelector('[data-nw-menu]');
    var scrim = root.querySelector('[data-nw-menu-scrim]');
    var closeBtn = panel ? panel.querySelector('[data-nw-close]') : null;

    /* estado scrolled */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* bolita que sigue al cursor sobre el menú (solo puntero fino) */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reducedM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dot = header.querySelector('[data-nw-cursor]');
    var row = header.querySelector('.nw-header__row');
    if (dot && row && fine.matches) {
      var tx = 0, ty = 0, cx = 0, cy = 0, rafId = null, alive = false;
      var ease = reducedM.matches ? 1 : 0.2;   /* sin trailing si reduce-motion */
      function tick() {
        cx += (tx - cx) * ease;
        cy += (ty - cy) * ease;
        dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px) scale(1)';
        if (alive || Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) {
          rafId = requestAnimationFrame(tick);
        } else { rafId = null; }
      }
      row.addEventListener('mousemove', function (e) {
        tx = e.clientX; ty = e.clientY;
        if (!rafId) rafId = requestAnimationFrame(tick);
      });
      row.addEventListener('mouseenter', function () {
        alive = true; dot.classList.add('is-visible');
        if (!rafId) rafId = requestAnimationFrame(tick);
      });
      row.addEventListener('mouseleave', function () {
        alive = false; dot.classList.remove('is-visible', 'is-lg');
      });
      /* crece sobre enlaces/botones interactivos del menú */
      row.querySelectorAll('a, button').forEach(function (el) {
        el.addEventListener('mouseenter', function () { dot.classList.add('is-lg'); });
        el.addEventListener('mouseleave', function () { dot.classList.remove('is-lg'); });
      });
    }

    /* panel móvil */
    function openMenu() {
      if (!panel) return;
      panel.hidden = false;
      scrim && (scrim.hidden = false);
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        scrim && scrim.classList.add('is-open');
      });
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    }
    function closeMenu() {
      if (!panel) return;
      panel.classList.remove('is-open');
      scrim && scrim.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        panel.hidden = true;
        scrim && (scrim.hidden = true);
      }, 560);
      burger.focus();
    }
    burger && burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      open ? closeMenu() : openMenu();
    });
    closeBtn && closeBtn.addEventListener('click', closeMenu);
    scrim && scrim.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger && burger.getAttribute('aria-expanded') === 'true') closeMenu();
    });

    /* idioma: cerrar el desplegable al hacer click en cualquier sitio fuera de él (o con Escape) */
    var lang = header.querySelector('[data-nw-lang]');
    if (lang) {
      document.addEventListener('click', function (e) {
        if (lang.open && !lang.contains(e.target)) lang.removeAttribute('open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lang.open) lang.removeAttribute('open');
      });
    }

  }

  /* contador de carrito: refresco tras cualquier add-to-cart */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-nw-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        });
      })
      .catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      window.setTimeout(refreshCartCount, 1400);
    }
  }, true);
  window.addEventListener('pageshow', refreshCartCount);

  function boot() {
    document.querySelectorAll('[data-nw-header]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-hero-b"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* VÍDEO. Dos cambios respecto a v3:
     1) prefers-reduced-motion: en v3 bootVideo no tenía NINGUNA guarda y llamaba a play()
        siempre, así que el vídeo full-bleed (la animación más grande de la pantalla) se
        reproducía para quien ha pedido no-motion. Ahora se sale antes de asignar la
        fuente: no se descarga y no se reproduce, se queda el póster.
     2) La fuente la pone SIEMPRE el JS (preload="none" en el HTML, sin <source>). En v3 la
        rama sin variante móvil llevaba preload="auto" + <source>, así que cada visita
        móvil se bajaba los 3,36MB del máster compitiendo con el LCP. */
  function bootVideo(root) {
    var vid = root.querySelector('[data-nw-herob-video]');
    if (!vid) return;
    if (REDUCE) return;
    vid.addEventListener('playing', function () { vid.classList.add('is-playing'); });
    vid.addEventListener('error', function () { vid.classList.remove('is-playing'); });
    var dsrc = vid.getAttribute('data-src');
    if (!dsrc) return;
    var dmob = vid.getAttribute('data-src-mobile');
    var useMob = dmob && window.matchMedia('(max-width: 767px)').matches;
    vid.src = useMob ? dmob : dsrc;
    vid.load();
    var pr = vid.play();
    if (pr && pr.catch) { pr.catch(function () {}); }
  }

  /* REVEAL pieza a pieza, sistema de la casa: una clase .is-in en la sección y el CSS
     resuelve el escalonado con data-stagger. Sin IntersectionObserver o con
     reduced-motion se marca is-in de entrada, así que nada depende del observer. */
  function bootReveal(sec) {
    if (REDUCE || !('IntersectionObserver' in window)) { sec.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); }
      });
    }, { threshold: 0.12 });
    io.observe(sec);
  }

  /* PARALLAX del fondo. Patrón EXACTO de ref-problema:
       p = (r.top + r.height/2 - vh/2) / vh   ->   translateY(p * -4%)
     La capa está sobredimensionada un 8% en CSS (inset:-4% 0) para que el recorrido no
     descubra el borde. Además da vida al póster mientras carga el vídeo. */
  function bootParallax(sec) {
    if (REDUCE) return;
    var layer = sec.querySelector('[data-nw-parallax]');
    if (!layer) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom > 0 && r.top < vh) {
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          layer.style.transform = 'translateY(' + (p * -4) + '%)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Marquee de logos de prensa: translateX con requestAnimationFrame, mismo motor que
     nw-prensa. La lista va pintada dos veces y al llegar a la mitad del scrollWidth se
     reinicia, así el bucle no da tirón.
     Con prefers-reduced-motion NO se arranca: el CSS deja la lista quieta, en una sola
     fila que CABE, sin scroll, porque la franja es decorativa y va bajo aria-hidden. */
  function bootMarquee(root) {
    var track = root.querySelector('[data-nw-herob-marquee]');
    var inner = root.querySelector('[data-nw-herob-marquee-inner]');
    if (!track || !inner || inner.dataset.nwMqReady) return;
    if (REDUCE) return;
    inner.dataset.nwMqReady = '1';

    var speed = window.innerWidth <= 749 ? 0.5 : 0.4;
    var pos = 0;
    /* PAUSA INICIAL (peticion de Juan 2026-09-09): al aterrizar, la tira ya estaba en
       movimiento y lo primero que se leia eran los medios del final de la lista
       (NutraSalud, TrailRun, Infosalus). Con una espera antes de arrancar, la primera
       impresion es el ORDEN DEL SETTING, o sea Glamour, El Mundo, Men's Health, Marca...
       Se cuenta desde que la seccion es visible, no desde el load, para que la espera
       no se consuma mientras el hero esta fuera de pantalla. */
    var holdMs = 2600;
    var startAt = 0;

    /* CENTRAR EL GRUPO FUERTE AL ATERRIZAR (peticion de Juan 2026-09-09).
       Un orden fijo en el setting no puede quedar centrado en todos los anchos: en 1440
       caben 9 logos y en 390 solo 3-4, asi que el mismo orden que centra en escritorio
       deja los secundarios delante en movil. Aqui se desplaza la tira para que el CENTRO
       del grupo marcado (data-key="hero") coincida con el centro del track, sea cual sea
       el ancho. La animacion arranca despues, desde esa posicion. */
    /* SIN OFFSET INICIAL. Se intento centrar el grupo por JS y no compensaba: entre el
       transform ya aplicado, la carga de los <img> y los recalculos, el offset se
       acumulaba y el grupo acababa desviado (128, 167, 178px en pruebas sucesivas).
       La tira arranca en 0 y son los HUECOS del setting los que colocan los medios
       fuertes en el centro del viewport: en 1440 caben 9 logos, asi que las posiciones
       3..6 caen alrededor del centro (720). La pausa inicial (holdMs) mantiene ese
       encuadre quieto mientras el visitante aterriza. */
    var startOffset = 0;
    var centered = true;
    var paused = false;
    function tick() {
      /* La animacion NO avanza hasta que el grupo esta centrado (centered=true) y ha
         pasado la pausa. Antes se llamaba a centerHeroGroup() varias veces (load de las
         imagenes, fonts.ready, resize) reseteando startAt, mientras el bucle seguia
         restando: el offset se acumulaba y el grupo acababa desviado, cada vez mas
         (medido 128px, luego 178px). Ahora el reloj arranca UNA vez, cuando ya esta
         centrado de verdad. */
      if (!centered) { requestAnimationFrame(tick); return; }
      if (!startAt) startAt = performance.now();
      if (!paused && performance.now() - startAt > holdMs) {
        pos -= speed;
        var half = inner.scrollWidth / 2;
        /* al completar media pasada se reinicia SOBRE el offset inicial, no en 0, para
           que el bucle sea continuo y no salte al arrancar el segundo ciclo */
        if (half > 0 && Math.abs(pos - startOffset) >= half) pos = startOffset;
        inner.style.transform = 'translateX(' + pos + 'px)';
      }
      requestAnimationFrame(tick);
    }
    /* Pausa al pasar el ratón: RETIRADA a propósito. Al pie del hero la franja va con
       pointer-events:none (no debe robarle ni un píxel de zona pulsable al CTA), así que
       un listener de mouseenter en el track no se dispararía NUNCA y era código muerto. */
    window.addEventListener('resize', function () {
      speed = window.innerWidth <= 749 ? 0.5 : 0.4;
    });
    /* Fuera de pantalla no gasta frames */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { paused = !e.isIntersecting; });
      }, { threshold: 0 });
      io.observe(track);
    }
    tick();
  }

  function boot(root) {
    if (root.dataset.nwHerobReady) return;
    root.dataset.nwHerobReady = '1';
    bootVideo(root); bootReveal(root); bootParallax(root); bootMarquee(root);
  }
  function bootAll() { document.querySelectorAll('.nw-herob').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nw-herob') : null;
    if (r) boot(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwHeroInit) return;
  window.__nwHeroInit = true;

  function init(hero) {
    if (!hero || hero.dataset.nwReady) return;
    hero.dataset.nwReady = '1';

    /* Vídeo hero: intentar reproducir y revelarlo SOLO cuando confirma reproducción ('playing').
       Si play() se rechaza (Safari bloquea autoplay en bajo consumo/datos) o el vídeo da error,
       no se revela y se queda la imagen fija — así nunca aparece el botón de play del sistema.
       IMPORTANTE: el vídeo de fondo debe reproducirse SIEMPRE, también con "reducir movimiento"
       (es la identidad del hero, no una animación de UI). Por eso va ANTES del guard `reduced`;
       antes estaba después y con reduce-motion el vídeo nunca arrancaba (solo se veía el poster). */
    var vid = hero.querySelector('[data-nw-hero-video]');
    if (vid) {
      vid.addEventListener('playing', function () { vid.classList.add('is-playing'); });
      vid.addEventListener('error', function () { vid.classList.remove('is-playing'); });
      /* Si la sección trae variante móvil, la fuente NO viene en el HTML (preload="none"):
         se elige aquí para no bajarse el vídeo de escritorio en un móvil. El máster 16:9
         recortado a cover se come el producto en pantallas estrechas, así que en móvil va
         un recorte vertical propio. Sin data-src el <source> ya viene del servidor y esto
         no toca nada. */
      var dsrc = vid.getAttribute('data-src');
      if (dsrc) {
        var dmob = vid.getAttribute('data-src-mobile');
        var useMob = dmob && window.matchMedia('(max-width: 767px)').matches;
        vid.src = useMob ? dmob : dsrc;
        vid.load();
      }
      var pr = vid.play();
      if (pr && pr.catch) { pr.catch(function () {}); }
    }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;   /* con reduce-motion: el vídeo sí, pero SIN parallax de scroll */

    var media = hero.querySelector('[data-nw-hero-media]');
    var imgs = hero.querySelectorAll('.nw-hero__img');
    if (!media || !imgs.length) return;

    /* parallax de salida ligado al scroll */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = hero.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom > 0 && rect.top < vh) {
          var p = Math.min(1, Math.max(0, -rect.top / vh));
          var tf = 'scale(' + (1 + p * 0.12) + ') translateY(' + (p * 8) + '%)';
          for (var k = 0; k < imgs.length; k++) { imgs[k].style.transform = tf; }
          media.style.opacity = String(1 - p * 0.45);
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function boot() { document.querySelectorAll('[data-nw-hero]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-home-slides"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwStackInit) return;
  window.__nwStackInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var applied = false;
  var wrappers = [];

  function collect() {
    var main = document.querySelector('#MainContent') || document.body;
    wrappers = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'))
      .filter(function (w) { return w.querySelector('[data-nw-slide], [data-nw-slide-attach]'); });
  }

  /* limpia cualquier resto del sistema anterior de escalado (margenes/--nw-fit inline) */
  function resetFit(w) {
    w.querySelectorAll('[data-nw-fit]').forEach(function (el) {
      el.style.removeProperty('--nw-fit');
      el.style.marginTop = '';
      el.style.marginBottom = '';
      el.style.transform = '';
    });
  }

  function apply() {
    collect();
    var vh = window.innerHeight;
    /* En las LANDINGS el apilado va DESACTIVADO (Juan pidió la 2ª y 3ª sección estáticas):
       stopIdx = 0 => ninguna sección se fija. En la HOME se mantiene el efecto original.
       Nota: no basta con sacar a "problema" del apilado — si el HERO sigue sticky, es él
       quien se queda pegado y el efecto de diapositiva se sigue viendo igual.
       El z-index incremental se conserva SIEMPRE: de él depende el solape de esquinas. */
    var esLanding = document.body.classList.contains('template-landing-page');
    var stopIdx = -1;
    if (esLanding) {
      stopIdx = 0;
    } else {
      for (var k = 0; k < wrappers.length; k++) {
        if (wrappers[k].querySelector('.nw-ciencia, .nw-sodio')) { stopIdx = k; break; }
      }
    }
    wrappers.forEach(function (w, i) {
      resetFit(w);
      w.style.zIndex = String(i + 1);
      w.style.minHeight = '';
      var slide = w.querySelector('[data-nw-slide], [data-nw-slide-attach]');
      if (slide) { slide.style.position = ''; slide.style.top = ''; slide.style.minHeight = ''; }
      var isStack = (stopIdx < 0) ? (i < wrappers.length - 1) : (i < stopIdx);
      if (!isStack) {
        /* flujo normal (ni la última ni las de después de ciencia se fijan) */
        w.style.position = 'relative';
        w.style.top = '';
        return;
      }
      w.style.position = 'sticky';
      var h = w.getBoundingClientRect().height;
      /* secciones ≤ viewport: se fijan arriba (top:0).
         secciones más altas que el viewport: se fijan por su base (bottom-aligned). */
      w.style.top = h <= vh + 1 ? '0px' : (vh - h) + 'px';
    });
    document.documentElement.classList.add('nw-stack-on');
    applied = true;
  }

  function clear() {
    wrappers.forEach(function (w) {
      w.style.position = ''; w.style.top = ''; w.style.zIndex = ''; w.style.minHeight = '';
      resetFit(w);
    });
    document.documentElement.classList.remove('nw-stack-on');
    applied = false;
  }

  function update() {
    /* Activo en todos los tamaños; solo se desactiva con "reducir movimiento" */
    var should = !reduced.matches;
    if (should) apply();       /* re-apply también en resize para recalcular tops */
    else if (applied) clear();
  }

  var rt;
  function onResize() { clearTimeout(rt); rt = setTimeout(update, 150); }

  function boot() {
    update();
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', function () { setTimeout(update, 200); }, { passive: true });
    (reduced.addEventListener ? reduced.addEventListener('change', update) : reduced.addListener(update));
    document.addEventListener('shopify:section:load', function () { setTimeout(update, 60); });
    /* recalcular cuando cargan imágenes/fuentes (cambian alturas) */
    window.addEventListener('load', function () { setTimeout(update, 150); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-legal"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwLegalInit) return;
  window.__nwLegalInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.08 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }
  }
  function boot() { document.querySelectorAll('.nw-legal[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-merch"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwMerchInit) return;
  window.__nwMerchInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) { sec.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
    }, { threshold: 0.05 });
    io.observe(sec);
  }
  function boot() { document.querySelectorAll('[data-nw-merch]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-momentos"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwOrbitInit) return;
  window.__nwOrbitInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var dots = Array.prototype.slice.call(sec.querySelectorAll('.nw-momentos__dot'));
    var moments = Array.prototype.slice.call(sec.querySelectorAll('.nw-momentos__moment'));

    dots.forEach(function (d, i) {
      var btn = d.querySelector('.nw-momentos__dot-btn');
      btn && btn.addEventListener('click', function () {
        dots.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
        moments.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
      });
    });

    /* Dial "¿cómo tomarlo?" a caballo: rueda de 3 pasos (anterior arriba / activo centro /
       siguiente abajo) con auto-rotación, pausa al hover y click manual. */
    var ctsteps = Array.prototype.slice.call(sec.querySelectorAll('.nw-momentos__ctstep'));
    if (ctsteps.length > 1) {
      var reducedCt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cn = ctsteps.length, cidx = 0, ctimer = null;
      // Orden natural fijo (1 arriba, 2, 3 abajo); solo se mueve el resaltado amarillo
      // de arriba a abajo. Sin reordenar (nada de rueda).
      var ctShow = function (i) {
        cidx = ((i % cn) + cn) % cn;
        ctsteps.forEach(function (s, j) {
          s.style.order = '';
          s.style.display = '';
          s.classList.toggle('is-active', j === cidx);
        });
      };
      var ctTick = function () { ctShow(cidx + 1); };
      var ctStart = function () { if (!reducedCt && !ctimer) ctimer = setInterval(ctTick, 2500); };
      var ctStop = function () { if (ctimer) { clearInterval(ctimer); ctimer = null; } };
      ctsteps.forEach(function (s, i) { s.addEventListener('click', function () { ctShow(i); ctStop(); ctStart(); }); });
      var ctdialEl = sec.querySelector('.nw-momentos__ctdial');
      if (ctdialEl) { ctdialEl.addEventListener('mouseenter', ctStop); ctdialEl.addEventListener('mouseleave', ctStart); }
      ctShow(0);
      ctStart();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) sec.classList.add('is-in'); });
      }, { threshold: 0.15 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-momentos[data-nw-orbit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-packs-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPacksInit) return;
  window.__nwPacksInit = true;

  /* Aquí vivían el marquee (rAF ligado al scroll en escritorio, automático en móvil, con
     su reset en resize) y el handler de add-to-cart del pill. La fila es estática y el pill
     es un enlace a la ficha, así que no queda nada de eso: solo el reveal de entrada. */
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.15 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }

  function boot() { document.querySelectorAll('.nw-packs[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2-bak-20260923"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1
    };
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas sin regalo, así que el ahorro sale 25% solo. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        all += s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = (all > paid) && (route !== 'ot' || DATA.otShowCompare);
      return {
        variant: 'multi',
        cents: paid,
        compareCents: (route === 'ot' && !DATA.otShowCompare) ? 0 : all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      var c = combo(S.boxes, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var pd = (route === 'sub' && freqSel && freqSel.value) ? planData(c, freqSel.value) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (S.boxes === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          var packCents = (packSrc && packSrc.cents) ? packSrc.cents : unit * 3;
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        if (route === 'ot' && !DATA.otShowCompare) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = (freqSel && freqSel.selectedIndex >= 0) ? freqSel.options[freqSel.selectedIndex].text : '';
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      card.classList.toggle('is-selected', route === S.route);
      if (radio && route === S.route && !radio.disabled) radio.checked = true;
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = isPack
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    var infoWrap = sec.querySelector('[data-nw-info-wrap]');
    var infoBtn = sec.querySelector('[data-nw-info]');
    if (infoWrap && infoBtn) {
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var needsFlavors = (S.boxes === '4' && !packComplete());

        if (esLanding && form && !needsFlavors) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2-bak-20261002"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1
    };
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas sin regalo, así que el ahorro sale 25% solo. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        all += s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = (all > paid) && (route !== 'ot' || DATA.otShowCompare);
      return {
        variant: 'multi',
        cents: paid,
        compareCents: (route === 'ot' && !DATA.otShowCompare) ? 0 : all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      var c = combo(S.boxes, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var pd = (route === 'sub' && freqSel && freqSel.value) ? planData(c, freqSel.value) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (S.boxes === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          var packCents = (packSrc && packSrc.cents) ? packSrc.cents : unit * 3;
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        if (route === 'ot' && !DATA.otShowCompare) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = (freqSel && freqSel.selectedIndex >= 0) ? freqSel.options[freqSel.selectedIndex].text : '';
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      card.classList.toggle('is-selected', route === S.route);
      if (radio && route === S.route && !radio.disabled) radio.checked = true;
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = isPack
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    var infoWrap = sec.querySelector('[data-nw-info-wrap]');
    var infoBtn = sec.querySelector('[data-nw-info]');
    if (infoWrap && infoBtn) {
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- bfcache: liberar la guarda al volver ATRÁS ----------
       `busy` se pone a true al enviar y solo se libera en el catch o en los modos
       drawer/stay. Con after_add = 'checkout' la página navega y busy se queda en true.
       Al volver atrás, el navegador restaura la página desde bfcache con el JS intacto
       (no se re-ejecuta la sección), así que el submit salía por `if (busy) return;` y
       el botón no respondía hasta refrescar. Reportado por Juan el 2026-09-23:
       "si le doy a Suscripción, añado al carrito, vuelvo a la landing, le doy a Compra
       única e intento añadir al carrito, no me funciona, tengo que refrescar".
       Afecta a las 11 plantillas que montan esta sección, todas con after_add=checkout. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;          /* carga normal: la sección ya arranca limpia */
      busy = false;
      if (addBtn) {
        addBtn.classList.remove('is-added');
        addBtn.textContent = DATA.copy.addLabel || addBtn.textContent;
      }
      showError('');
    });

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var needsFlavors = (S.boxes === '4' && !packComplete());

        if (esLanding && form && !needsFlavors) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2-bak-20261002b"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1
    };
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas sin regalo, así que el ahorro sale 25% solo. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        all += s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = (all > paid) && (route !== 'ot' || DATA.otShowCompare);
      return {
        variant: 'multi',
        cents: paid,
        compareCents: (route === 'ot' && !DATA.otShowCompare) ? 0 : all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      var c = combo(S.boxes, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var pd = (route === 'sub' && freqSel && freqSel.value) ? planData(c, freqSel.value) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (S.boxes === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          var packCents = (packSrc && packSrc.cents) ? packSrc.cents : unit * 3;
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        if (route === 'ot' && !DATA.otShowCompare) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = (freqSel && freqSel.selectedIndex >= 0) ? freqSel.options[freqSel.selectedIndex].text : '';
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      card.classList.toggle('is-selected', route === S.route);
      if (radio && route === S.route && !radio.disabled) radio.checked = true;
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = isPack
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    var infoWrap = sec.querySelector('[data-nw-info-wrap]');
    var infoBtn = sec.querySelector('[data-nw-info]');
    if (infoWrap && infoBtn) {
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- bfcache: liberar la guarda al volver ATRÁS ----------
       `busy` se pone a true al enviar y solo se libera en el catch o en los modos
       drawer/stay. Con after_add = 'checkout' la página navega y busy se queda en true.
       Al volver atrás, el navegador restaura la página desde bfcache con el JS intacto
       (no se re-ejecuta la sección), así que el submit salía por `if (busy) return;` y
       el botón no respondía hasta refrescar. Reportado por Juan el 2026-09-23:
       "si le doy a Suscripción, añado al carrito, vuelvo a la landing, le doy a Compra
       única e intento añadir al carrito, no me funciona, tengo que refrescar".
       Afecta a las 11 plantillas que montan esta sección, todas con after_add=checkout. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;          /* carga normal: la sección ya arranca limpia */
      busy = false;
      if (addBtn) {
        addBtn.classList.remove('is-added');
        addBtn.textContent = DATA.copy.addLabel || addBtn.textContent;
      }
      showError('');
    });

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen.

           PDP (Juan, 2026-10-02): la ficha de producto pasa a comprar directo igual que
           la landing. Se activa por plantilla con el ajuste `float_direct_add`, encendido
           en product.out-of-stock-preventa.json (la plantilla que usan, pese al nombre,
           las 6 fichas de LIT Daily Hydration). No va por clase del body: asi afiliados
           sigue llevando a la ficha.
           Si el boton real esta desactivado ("No disponible"), el submit no haria nada
           visible: tambien se lleva a la ficha, que es donde se ve el motivo. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var directAdd = esLanding || (floatBar && floatBar.getAttribute('data-direct') === '1');
        var needsFlavors = (S.boxes === '4' && !packComplete());
        var addBlocked = !!(addBtn && addBtn.disabled);

        if (directAdd && form && !needsFlavors && !addBlocked) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2-bak-20261002c"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1
    };
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas sin regalo, así que el ahorro sale 25% solo. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        all += s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = (all > paid) && (route !== 'ot' || DATA.otShowCompare);
      return {
        variant: 'multi',
        cents: paid,
        compareCents: (route === 'ot' && !DATA.otShowCompare) ? 0 : all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      var c = combo(S.boxes, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var pd = (route === 'sub' && freqSel && freqSel.value) ? planData(c, freqSel.value) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (S.boxes === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          var packCents = (packSrc && packSrc.cents) ? packSrc.cents : unit * 3;
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        if (route === 'ot' && !DATA.otShowCompare) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = (freqSel && freqSel.selectedIndex >= 0) ? freqSel.options[freqSel.selectedIndex].text : '';
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      card.classList.toggle('is-selected', route === S.route);
      if (radio && route === S.route && !radio.disabled) radio.checked = true;
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = isPack
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    var infoWrap = sec.querySelector('[data-nw-info-wrap]');
    var infoBtn = sec.querySelector('[data-nw-info]');
    if (infoWrap && infoBtn) {
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- bfcache: liberar la guarda al volver ATRÁS ----------
       `busy` se pone a true al enviar y solo se libera en el catch o en los modos
       drawer/stay. Con after_add = 'checkout' la página navega y busy se queda en true.
       Al volver atrás, el navegador restaura la página desde bfcache con el JS intacto
       (no se re-ejecuta la sección), así que el submit salía por `if (busy) return;` y
       el botón no respondía hasta refrescar. Reportado por Juan el 2026-09-23:
       "si le doy a Suscripción, añado al carrito, vuelvo a la landing, le doy a Compra
       única e intento añadir al carrito, no me funciona, tengo que refrescar".
       Afecta a las 11 plantillas que montan esta sección, todas con after_add=checkout. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;          /* carga normal: la sección ya arranca limpia */
      busy = false;
      if (addBtn) {
        addBtn.classList.remove('is-added');
        addBtn.textContent = DATA.copy.addLabel || addBtn.textContent;
      }
      showError('');
    });

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen.

           PDP (Juan, 2026-10-02): la ficha de producto pasa a comprar directo igual que
           la landing. Se activa por plantilla con el ajuste `float_direct_add`, encendido
           en product.out-of-stock-preventa.json (la plantilla que usan, pese al nombre,
           las 6 fichas de LIT Daily Hydration). No va por clase del body: asi afiliados
           sigue llevando a la ficha.
           Si el boton real esta desactivado ("No disponible"), el submit no haria nada
           visible: tambien se lleva a la ficha, que es donde se ve el motivo. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var directAdd = esLanding || (floatBar && floatBar.getAttribute('data-direct') === '1');
        var needsFlavors = (S.boxes === '4' && !packComplete());
        var addBlocked = !!(addBtn && addBtn.disabled);

        if (directAdd && form && !needsFlavors && !addBlocked) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1
    };
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');
    /* LIT (2026-10-07): ficha del pack (catálogos de Meta/TikTok). Los 4 huecos salen de la mezcla
       de la variante del enlace: PACK4-2L1W1P = 2 Salty Lemon, 1 Watermelon, 1 Peach. */
    if (DATA.packPreset && S.boxes === '4') {
      var PF = { L: 'lit-daily-hydration', W: 'lit-daily-hydration-watermelon', P: 'lit-daily-hydration-peach' };
      var pre = [];
      String(DATA.packPreset).replace(/(\d)([LWP])/g, function (m0, n, f) { for (var k = 0; k < +n; k++) pre.push(PF[f]); return m0; });
      if (pre.length === 4 && pre.every(function (h) { return flavorOrder.indexOf(h) !== -1; })) S.slots = pre;
    }

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas en COMPRA ÚNICA (4 x 37,80 = 151,20), en las dos
       rutas. Juan, 5-oct-2026: antes eran 4 cajas al precio de la ruta (113,40 en suscripción)
       y en compra única no salía. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1, o1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        o1 = DATA.combos['1|ot|' + slots[i]];
        all += (o1 && o1.cents) ? o1.cents : s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = all > paid;
      return {
        variant: 'multi',
        cents: paid,
        compareCents: all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      var c = combo(S.boxes, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var pd = (route === 'sub' && freqSel && freqSel.value) ? planData(c, freqSel.value) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (S.boxes === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          /* Oct-2026: el descuento vive en el plan, así que el pack se lee de SU frecuencia
             (packEntry con plan), no de la base sin plan. */
          var packPd = (route === 'sub' && pd && freqSel && freqSel.value) ? planData(packSrc, freqSel.value) : null;
          var packCents = (packPd && packPd.cents) ? packPd.cents : ((packSrc && packSrc.cents) ? packSrc.cents : unit * 3);
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        /* En compra única solo lleva tachado lo que lleva caja gratis: el pack y, con 1 caja, de 4
           unidades en adelante, que ya se cobran con packs (Juan, 5 y 6-oct-2026). */
        if (route === 'ot' && !DATA.otShowCompare && !(S.boxes === '4' || q >= 4)) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = (freqSel && freqSel.selectedIndex >= 0) ? freqSel.options[freqSel.selectedIndex].text : '';
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      card.classList.toggle('is-selected', route === S.route);
      if (radio && route === S.route && !radio.disabled) radio.checked = true;
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = isPack
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    var infoWrap = sec.querySelector('[data-nw-info-wrap]');
    var infoBtn = sec.querySelector('[data-nw-info]');
    if (infoWrap && infoBtn) {
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        /* LIT: tope ya al teclear; antes 15 enseñaba 340,20 hasta salir del campo y luego cobraba 10 */
        var maxQ = DATA.maxQty || 10;
        if (parseInt(qtyInput.value, 10) > maxQ) qtyInput.value = maxQ;
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        /* LIT (2026-10-06): lo elegido aquí SUSTITUYE a las cajas LIT que ya hubiera en el carrito.
           Antes se acumulaba (volver atrás desde el checkout y añadir otra vez): 1 caja + 3 cajas
           quedaban como SL30 x4 = 113,40 en vez del pack de 85,05. Mismas cajas, mismo precio.
           Si leer o vaciar el carrito falla, se añade igual: nunca bloqueamos la compra. */
        var litBox = /^lit-daily-hydration|^lit-pack-4-cajas/;
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var upd = {}, n = 0;
            ((cart && cart.items) || []).forEach(function (it) {
              if (it && litBox.test(String(it.handle || ''))) { upd[it.key] = 0; n++; }
            });
            if (!n) return null;
            return fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ updates: upd }) });
          })
          .catch(function () { return null; })
          .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers }); })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- bfcache: liberar la guarda al volver ATRÁS ----------
       `busy` se pone a true al enviar y solo se libera en el catch o en los modos
       drawer/stay. Con after_add = 'checkout' la página navega y busy se queda en true.
       Al volver atrás, el navegador restaura la página desde bfcache con el JS intacto
       (no se re-ejecuta la sección), así que el submit salía por `if (busy) return;` y
       el botón no respondía hasta refrescar. Reportado por Juan el 2026-09-23:
       "si le doy a Suscripción, añado al carrito, vuelvo a la landing, le doy a Compra
       única e intento añadir al carrito, no me funciona, tengo que refrescar".
       Afecta a las 11 plantillas que montan esta sección, todas con after_add=checkout. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;          /* carga normal: la sección ya arranca limpia */
      busy = false;
      if (addBtn) {
        addBtn.classList.remove('is-added');
        addBtn.textContent = DATA.copy.addLabel || addBtn.textContent;
      }
      showError('');
    });

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen.

           PDP (Juan, 2026-10-02): la ficha de producto pasa a comprar directo igual que
           la landing. Se activa por plantilla con el ajuste `float_direct_add`, encendido
           en product.out-of-stock-preventa.json (la plantilla que usan, pese al nombre,
           las 6 fichas de LIT Daily Hydration). No va por clase del body: asi afiliados
           sigue llevando a la ficha.
           Si el boton real esta desactivado ("No disponible"), el submit no haria nada
           visible: tambien se lleva a la ficha, que es donde se ve el motivo. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var directAdd = esLanding || (floatBar && floatBar.getAttribute('data-direct') === '1');
        var needsFlavors = (S.boxes === '4' && !packComplete());
        var addBlocked = !!(addBtn && addBtn.disabled);

        var fbMode = (directAdd && form && !needsFlavors && !addBlocked) ? 'compra' : 'scroll';
        /* Rastro de la barra flotante (Kiko, 2026-10-02): GTM lo manda a GA4 como `floatbar_click`
           con floatbar_mode (compra | scroll) y floatbar_page, para saber qué parte del carrito
           viene de la barra. */
        try {
          (window.dataLayer = window.dataLayer || []).push({ event: 'floatbar_click', floatbar_mode: fbMode, floatbar_page: window.location.pathname });
        } catch (e) { /* sin dataLayer la barra sigue funcionando */ }

        if (fbMode === 'compra') {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-buy-box-v2t"]) return;
  try {
    
(function () {
  if (window.__nwPdp2Init) return;
  window.__nwPdp2Init = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReadyT) return;
    sec.dataset.nwReadyT = '1';

    /* ---------- datos ---------- */
    var DATA = { combos: {}, flavors: {}, gifts: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdp2-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.combos = DATA.combos || {};
    DATA.flavors = DATA.flavors || {};
    DATA.gifts = DATA.gifts || {};
    DATA.packVariants = DATA.packVariants || { sub: {}, ot: {} };
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var galEl = sec.querySelector('.nw-pdp__gallery');
    var infoEl = sec.querySelector('.nw-pdp__info');
    var stage = sec.querySelector('.nw-pdp__stage');
    function clearCols() {
      if (galEl) galEl.style.height = '';
      if (infoEl) infoEl.style.maxHeight = '';
      if (stage) stage.style.height = '';
    }
    clearCols();
    window.addEventListener('resize', clearCols, { passive: true });

    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function bindThumbs() {
      thumbs.forEach(function (t) {
        if (t.dataset.nwThumbBound) return;
        t.dataset.nwThumbBound = '1';
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-thumb');
          if (galSwipeable()) {
            var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
            if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
          galSetActive(i);
        });
      });
    }
    bindThumbs();
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          galTick = false;
          var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
          });
          galSetActive(best);
        });
      }, { passive: true });
    }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = !galRoot || galRoot.getAttribute('data-nw-autoplay') !== 'false';
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');
    function galCount() { return sec.querySelectorAll('.nw-pdp__slide').length; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      sec.querySelectorAll('.nw-pdp__slide').forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = galCount(); if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    function updateNav() {
      var many = galCount() > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    updateNav();
    var autoPaused = false, resumeT = null;
    function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
    if (autoplayOn && stage) {
      setInterval(function () { if (!autoPaused && galCount() > 1) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; clearTimeout(resumeT); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) autoPaused = true; });
    }
    if (navPrev) navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); pauseTemp(); });
    if (navNext) navNext.addEventListener('click', function () { galGo(galCurrent() + 1); pauseTemp(); });

    function applyGallery(urls) {
      if (!urls || !urls.length || !stage) return;
      stage.innerHTML = urls.map(function (u, i) {
        return '<div class="nw-pdp__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
          '<img class="nw-pdp__stage-img" src="' + u + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="1200"></div>';
      }).join('');
      var thumbsWrap = sec.querySelector('.nw-pdp__thumbs');
      if (!thumbsWrap && urls.length > 1) {
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'nw-pdp__thumbs';
        thumbsWrap.setAttribute('role', 'tablist');
        if (galRoot) galRoot.appendChild(thumbsWrap);
      }
      if (thumbsWrap) {
        if (urls.length > 1) {
          thumbsWrap.innerHTML = urls.slice(0, 7).map(function (u, i) {
            return '<button type="button" class="nw-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + i + '" aria-label="' + ((DATA.copy && DATA.copy.viewImage) || 'Ver imagen') + ' ' + (i + 1) + '"><img src="' + u + '" loading="lazy" alt="" width="300" height="300"></button>';
          }).join('');
          thumbsWrap.style.display = '';
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.style.display = 'none';
        }
      }
      slides = sec.querySelectorAll('.nw-pdp__slide');
      thumbs = sec.querySelectorAll('.nw-pdp__thumb');
      bindThumbs();
      try { stage.scrollLeft = 0; } catch (e) {}
      galSetActive(0);
      updateNav();
    }

    /* ---------- estado ---------- */
    var form = sec.querySelector('[data-nw-pdp2-form]');
    var idInput = sec.querySelector('[data-nw-id]');
    var freqSel = sec.querySelector('[data-nw-freq]');
    var qtyInput = sec.querySelector('[data-nw-qty]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var errEl = sec.querySelector('[data-nw-error]');
    var boxCards = sec.querySelectorAll('[data-nw-box-card]');
    var routeCards = sec.querySelectorAll('[data-nw-route-card]');
    var flavorCards = sec.querySelectorAll('[data-nw-flavor-card]');
    var slotBtns = sec.querySelectorAll('[data-nw-slot]');
    var propInputs = sec.querySelectorAll('[data-nw-prop]');
    var propSummary = sec.querySelector('[data-nw-prop-summary]');
    var flavorHeading = sec.querySelector('[data-nw-flavor-heading]');
    var flavorLabelEl = sec.querySelector('[data-nw-flavor-label]');
    var boxNoteEl = sec.querySelector('[data-nw-box-note]');
    var accBodies = sec.querySelectorAll('[data-nw-acc-body]');
    var slotsLive = sec.querySelector('[data-nw-slots-live]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');

    var flavorOrder = [];
    flavorCards.forEach(function (c) { flavorOrder.push(c.getAttribute('data-flavor')); });

    var S = {
      boxes: sec.getAttribute('data-nw-boxes') || '1',
      route: sec.getAttribute('data-nw-route') || 'sub',
      flavor: sec.getAttribute('data-nw-flavor') || flavorOrder[0] || '',
      slots: [],
      activeSlot: 1,
      mix: false,          /* test de la caja: el pack es de UN sabor hasta pulsar "Mezclar sabores" */
      freqBy: {}           /* frecuencia elegida a mano en cada tarjeta de suscripción ('1' / '4') */
    };
    var freqWrap = sec.querySelector('[data-nw-freq-wrap]');
    var mixBtn = sec.querySelector('[data-nw-mix-toggle]');
    var packFlavorsEl = sec.querySelector('[data-nw-pack-flavors]');
    var slotsEl = sec.querySelector('[data-nw-slots]');
    function defaultPlanFor(nb) { return String(nb === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1); }
    function planLabel(id) {
      if (!freqSel || !id) return '';
      for (var i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value === String(id)) return freqSel.options[i].text;
      }
      return '';
    }
    slotBtns.forEach(function (b) { S.slots.push(b.getAttribute('data-flavor') || ''); });
    while (S.slots.length < 4) S.slots.push('');

    /* DEEP LINK ?sabor=<handle> — abre la ficha con un sabor ya elegido.
       Lo usa la fila de cajas de la home: las 3 llevan a la ficha general (limón) y cada una
       preselecciona el suyo, en vez de mandar a 3 fichas distintas.
       Acepta el handle completo (lit-daily-hydration-peach) o el sufijo corto (peach), y
       'flavor' como alias en inglés. Solo aplica si ese sabor está entre los de la ficha y
       está disponible: un sabor no publicado se ignora y se queda el de la ficha. */
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = (qs.get('sabor') || qs.get('flavor') || '').trim().toLowerCase();
      if (want) {
        var hit = '';
        for (var fi = 0; fi < flavorOrder.length; fi++) {
          var h = String(flavorOrder[fi] || '');
          if (h.toLowerCase() === want) { hit = h; break; }
          if (h.toLowerCase().indexOf('-' + want) === h.length - want.length - 1 && want.length) { hit = h; }
        }
        if (hit) {
          var hitCard = sec.querySelector('[data-nw-flavor-card][data-flavor="' + hit + '"]');
          if (!hitCard || hitCard.getAttribute('data-available') === '1') S.flavor = hit;
        }
      }
    } catch (e) { /* URLSearchParams no soportado: se queda el sabor de la ficha */ }

    /* El pack no se puede añadir hasta que los 4 huecos tengan sabor. */
    function packComplete() {
      return S.slots.length === 4 && S.slots.every(function (h) { return !!h; });
    }
    /* Tras asignar un sabor, el cursor salta al siguiente hueco VACÍO (no al siguiente a secas). */
    function nextEmptySlot(from) {
      for (var i = 0; i < 4; i++) {
        var n = ((from - 1 + i) % 4) + 1;
        if (!S.slots[n - 1]) return n;
      }
      return ((from - 1) % 4) + 1;
    }

    function comboKey(boxes, route) {
      return boxes + '|' + route + '|' + (boxes === '4' ? '*' : S.flavor);
    }
    function combo(boxes, route) { return DATA.combos[comboKey(boxes, route)] || null; }

    /* Con el pack ya no hay variantes de mezcla: '4|<ruta>|*' es un combo sintético cuyo `variant`
       vale 'multi'. Esta función solo sirve para saber si la combinación activa es comprable. */
    function variantFor(boxes, route) {
      var c = combo(boxes, route);
      var v = c && c.variant ? String(c.variant) : '';
      /* Opción B: cada frecuencia vende su propia variante del ladder. */
      if (route === 'sub' && freqSel && freqSel.value) {
        var pdv = planData(c, freqSel.value);
        if (pdv && pdv.variant) v = String(pdv.variant);
      }
      return v;
    }
    function labelOf(handle) {
      var f = DATA.flavors[handle];
      return (f && f.label) ? f.label : handle;
    }
    /* Datos de UNA frecuencia: precio, tachado, €/sobre y % de ahorro propios de ese plan. */
    function planData(c, planId) {
      if (!c || !c.plans) return null;
      var d = c.plans[planId];
      if (!d) return null;
      return (typeof d === 'string') ? { price: d, compare: '', per: '', save: '' } : d;
    }
    function comboHasPlans(c) {
      return !!(c && c.plans && Object.keys(c.plans).length);
    }

    /* Formato de dinero para los múltiplos (qty > 1). Con qty 1 se usa siempre la cadena que
       formatea Shopify en Liquid, así que el caso normal no depende de esta función. */
    function money(cents) {
      var n = (Math.round(cents) / 100).toFixed(2).split('.');
      return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + '\u20AC';
    }
    /* Cada 4 cajas una es gratis, contando tambien los restos: con N cajas se pagan N - floor(N/4).
       Se consigue con la combinacion optima de floor(N/4) packs + (N mod 4) cajas sueltas:
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            6 -> 1 pack + 2 sueltas      = 141,75  (paga 5)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
       El importe crece siempre con la cantidad, asi que no hay tramos donde salga mejor pedir mas.
       De aqui salen tanto el precio que se muestra como las lineas del carrito, asi que mostrado
       y cobrado no se pueden desincronizar. */
    function groupBoxes(n) {
      var packs = Math.floor(n / 4);
      return { packs: packs, singles: n % 4, payable: n - packs };
    }

    /* ============================================================================
       EL PACK 3+1 NO ES UN PRODUCTO: son 3 cajas reales de pago + 1 caja regalo a 0,00.
       De aquí sale todo lo que antes se leía del producto pack.
       ============================================================================ */

    /* Los 4 sabores del pack. Con "1 caja" seleccionada se usa el sabor activo en los cuatro,
       para que la tarjeta del pack ya muestre su precio antes de tocar los huecos. */
    function packSlots() {
      var out = [], i;
      for (i = 0; i < 4; i++) out.push((S.boxes === '4' ? S.slots[i] : '') || S.flavor);
      return out;
    }
    function giftOf(handle) { return (DATA.gifts && DATA.gifts[handle]) || null; }
    /* Clave de mezcla: recuento por sabor en el orden de los bloques ("3-1" = 3 del 1o, 1 del 2o). */
    function packMixKey() {
      var sl = packSlots();
      return flavorOrder.map(function (h) {
        return sl.filter(function (x) { return x === h; }).length;
      }).join('-');
    }
    function packVariantFor(route) {
      var m = (DATA.packVariants && DATA.packVariants[route]) || {};
      return m[packMixKey()] || null;
    }
    function planIds() {
      var out = [], i;
      if (!freqSel) return out;
      for (i = 0; i < freqSel.options.length; i++) {
        if (freqSel.options[i].value) out.push(freqSel.options[i].value);
      }
      return out;
    }
    function perTxtOf(cents, units) {
      if (!units) return '';
      return money(Math.ceil(cents / units)).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
    }
    /* Precio del pack para una ruta y una frecuencia: se pagan los huecos 1-3 y el 4 es el regalo.
       El tachado es lo que costarían las 4 cajas en COMPRA ÚNICA (4 x 37,80 = 151,20), en las dos
       rutas. Juan, 5-oct-2026: antes eran 4 cajas al precio de la ruta (113,40 en suscripción)
       y en compra única no salía. */
    function packEntry(route, planId) {
      var slots = packSlots(), paid = 0, all = 0, units = 0, i, c1, pd1, s1, o1;
      for (i = 0; i < 4; i++) {
        c1 = DATA.combos['1|' + route + '|' + slots[i]];
        pd1 = (route === 'sub' && planId) ? planData(c1, planId) : null;
        s1 = pd1 || c1;
        if (!s1 || !s1.cents) return null;
        o1 = DATA.combos['1|ot|' + slots[i]];
        all += (o1 && o1.cents) ? o1.cents : s1.cents;
        if (i < 3) paid += s1.cents;
        units += (s1.units || 30);
        /* Aqui YA NO se comprueba nada del producto de caja regalo: el pack es un producto con
           su variante por mezcla y el regalo esta archivado. Mientras esta comprobacion siguio
           viva, archivar el regalo tumbo la ruta de suscripcion del pack en LIVE sin avisar
           (20-ago-2026). Las frecuencias validas salen de las cajas de 1, que son las que
           llevan los planes de Seal, y el precio del pack es la suma de los huecos 1-3. */
      }
      /* sin variante mapeada para esta mezcla, el pack no se puede vender */
      if (!packVariantFor(route)) return null;
      var showCmp = all > paid;
      return {
        variant: 'multi',
        cents: paid,
        compareCents: all,
        price: money(paid),
        compare: showCmp ? money(all) : '',
        per: perTxtOf(paid, units),
        save: (route === 'sub' && all > paid) ? ((DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((all - paid) * 100 / all) + '%') : '',
        units: units
      };
    }
    /* Escribe los combos sintéticos del pack donde el resto del pintado ya los busca. */
    function rebuildPackCombos() {
      ['sub', 'ot'].forEach(function (route) {
        var key = '4|' + route + '|*';
        var base = packEntry(route, null);
        if (!base) { delete DATA.combos[key]; return; }
        base.plans = {};
        if (route === 'sub') {
          planIds().forEach(function (id) {
            var e = packEntry('sub', id);
            if (e) base.plans[id] = e;
          });
          if (!Object.keys(base.plans).length) { delete DATA.combos[key]; return; }
        }
        DATA.combos[key] = base;
      });
    }

    /* Las líneas que se mandan a /cart/add.js. El sabor viaja en el SKU de cada línea (SL30/W30),
       así que el almacén no necesita properties para saber qué meter en la caja. */
    function buildItems() {
      var route = S.route;
      var planId = (route === 'sub' && freqSel && !freqSel.disabled && freqSel.value) ? Number(freqSel.value) : null;
      var q = currentQty();
      var paid = {}, gift = {}, items = [], h;
      function bump(m, k, n) { if (k && n > 0) m[k] = (m[k] || 0) + n; }
      /* EL PACK ES UN PRODUCTO CON SU PROPIA VARIANTE POR MEZCLA. Una sola linea en el carrito,
         con su precio, sin nada gratis ni editable. Hive la descompone por su lado (Hive Bundle:
         PACK4-2L2W = SL30 x2 + W30 x2). Asi desaparece la variante a 0 EUR y con ella el permalink,
         el regalo huerfano y las guardas. */
      if (S.boxes === '4') {
        var vpack = packVariantFor(route);
        if (!vpack) return null;
        var itp = { id: Number(vpack), quantity: q };
        if (planId) itp.selling_plan = planId;
        return [itp];
      }
      /* Ruta de 1 caja: cada 4 cajas una es gratis, y eso se consigue metiendo la COMBINACION
         OPTIMA: floor(N/4) unidades del pack del sabor elegido + las N mod 4 sueltas que sobren.
         Da el importe exacto de "se pagan N - floor(N/4)":
            4 -> 1 pack                  = 85,05   (paga 3)
            5 -> 1 pack + 1 suelta       = 113,40  (paga 4)
            8 -> 2 packs                 = 170,10  (paga 6)
           12 -> 3 packs                 = 255,15  (paga 9)
         Y sigue sin haber ninguna linea gratis: el descuento vive en el precio del pack, que Hive
         descompone en 4 cajas del mismo sabor. */
      var gr = groupBoxes(q);
      if (gr.packs > 0) {
        var vp1 = packVariantFor(route);   /* con 1 caja, packMixKey() da "4-0" o "0-4" */
        if (!vp1) return null;
        var itp1 = { id: Number(vp1), quantity: gr.packs };
        if (planId) itp1.selling_plan = planId;
        items.push(itp1);
      }
      bump(paid, S.flavor, gr.singles);
      for (h in paid) {
        if (!Object.prototype.hasOwnProperty.call(paid, h)) continue;
        var c = DATA.combos['1|' + route + '|' + h];
        var vid = c && c.variant;
        if (route === 'sub' && planId) {
          var pdv = planData(c, String(planId));
          if (pdv && pdv.variant) vid = pdv.variant;
        }
        if (!vid) return null;
        var it = { id: Number(vid), quantity: paid[h] };
        if (planId) it.selling_plan = planId;
        items.push(it);
      }
      for (h in gift) {
        if (!Object.prototype.hasOwnProperty.call(gift, h)) continue;
        var g = giftOf(h);
        if (!g || !g.variant) return null;
        var ig = { id: Number(g.variant), quantity: gift[h] };
        if (planId) {
          /* sin el plan en la caja regalo la renovación enviaría 3 cajas: mejor no vender */
          if (!g.plans || !g.plans[String(planId)]) return null;
          ig.selling_plan = planId;
        }
        items.push(ig);
      }
      return items.length ? items : null;
    }
    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.hidden = false; }
      else { errEl.textContent = ''; errEl.hidden = true; }
    }

    /* Si la ruta activa no es comprable, salta a la otra. */
    function ensureRoute() {
      var c = combo(S.boxes, S.route);
      var ok = !!(c && c.variant);
      if (S.route === 'sub' && ok) ok = comboHasPlans(c);
      if (ok) return;
      var alt = S.route === 'sub' ? 'ot' : 'sub';
      var ca = combo(S.boxes, alt);
      var altOk = !!(ca && ca.variant);
      if (alt === 'sub' && altOk) altOk = comboHasPlans(ca);
      if (altOk) S.route = alt;
    }

    function paintRouteCard(card) {
      var route = card.getAttribute('data-route');
      /* test de la caja: cada tarjeta lleva su nº de cajas (1 / pack / 1) y se pinta con él,
         esté o no elegida. La elegida usa el desplegable real; las otras, su frecuencia. */
      var cb = card.getAttribute('data-boxes') || S.boxes;
      var isActive = (route === S.route && cb === S.boxes);
      var c = combo(cb, route);
      var priceEl = card.querySelector('[data-nw-price]');
      var cmpEl = card.querySelector('[data-nw-compare]');
      var perEl = card.querySelector('[data-nw-per]');
      var saveEl = card.querySelector('[data-nw-save]');
      var radio = card.querySelector('input[type=radio]');

      var usable = !!(c && c.variant);
      if (route === 'sub' && usable) usable = comboHasPlans(c);
      card.classList.toggle('is-unavailable', !usable);
      if (radio) radio.disabled = !usable;

      /* En suscripción manda el allocation de la frecuencia elegida (precio, tachado, €/sobre y
         ahorro); si no hay plan resuelto, se cae a los valores del combo. */
      var planId = '';
      if (route === 'sub') planId = (isActive && freqSel && freqSel.value) ? freqSel.value : (S.freqBy[cb] || defaultPlanFor(cb));
      var pd = (route === 'sub' && planId) ? planData(c, planId) : null;
      var priceTxt = (pd && pd.price) ? pd.price : (c ? c.price : '');
      var cmpTxt = pd ? (pd.compare || '') : (c ? (c.compare || '') : '');
      var perTxt = (pd && pd.per) ? pd.per : (c ? c.per : '');
      var saveTxt = pd ? (pd.save || '') : (c ? (c.save || '') : '');
      /* El precio mostrado es el TOTAL y refleja el contador. En la ruta de 1 caja se aplica
         "cada 4 una gratis"; el pack ya lleva el regalo dentro, así que ahí multiplica lineal. */
      var q = currentQty();
      var src = pd || c;
      var unit = src && src.cents ? src.cents : 0;
      var unitCmp = src && src.compareCents ? src.compareCents : 0;
      if (q > 1 && unit) {
        var total, cmpTotal;
        if (cb === '1') {
          /* misma aritmetica que buildItems: packs + sueltas, para que mostrado == cobrado */
          var grp = groupBoxes(q);
          var packSrc = DATA.combos['4|' + route + '|*'];
          /* Oct-2026: el descuento vive en el plan, así que el pack se lee de SU frecuencia
             (packEntry con plan), no de la base sin plan. */
          var packPd = (route === 'sub' && planId) ? planData(packSrc, planId) : null;
          var packCents = (packPd && packPd.cents) ? packPd.cents : ((packSrc && packSrc.cents) ? packSrc.cents : unit * 3);
          total = grp.packs * packCents + grp.singles * unit;
          cmpTotal = unitCmp ? unitCmp * q : 0;
          if (!cmpTotal && grp.packs > 0) cmpTotal = unit * q;
        } else {
          total = unit * q;
          cmpTotal = unitCmp * q;
        }
        priceTxt = money(total);
        var showCmpTotal = cmpTotal > total;
        /* En compra única solo lleva tachado lo que lleva caja gratis: el pack y, con 1 caja, de 4
           unidades en adelante, que ya se cobran con packs (Juan, 5 y 6-oct-2026). */
        if (route === 'ot' && !DATA.otShowCompare && !(cb === '4' || q >= 4)) showCmpTotal = false;
        cmpTxt = showCmpTotal ? money(cmpTotal) : '';
        /* €/sobre y ahorro recalculados sobre el total: son los que de verdad paga */
        var unitsPer = (src && src.units) ? src.units : 30;
        if (unitsPer > 0) perTxt = money(Math.ceil(total / (unitsPer * q))).replace('\u20AC', '') + (DATA.copy.perSuffix || '');
        if (cmpTotal > total && route === 'sub') {
          saveTxt = (DATA.copy.savePrefix || 'Ahorra') + ' ' + Math.round((cmpTotal - total) * 100 / cmpTotal) + '%';
        }
      }
      /* test de la caja: "N cajas · M sobres" sigue a la cantidad y a la frecuencia
         (con el mapa frecuencia→variante, 3 meses son 90 sobres) */
      var unitsEl = card.querySelector('[data-nw-units]');
      if (unitsEl) {
        var u1 = DATA.copy.box1Units || 30;
        var pdQ = (pd && pd.qty) ? parseInt(pd.qty, 10) : 0;
        var sob = (pdQ || ((src && src.units) ? src.units : (cb === '4' ? u1 * 4 : u1))) * q;
        var caj = Math.max(1, Math.round(sob / u1));
        var sobTxt = sob + ' ' + (DATA.copy.unitsSachets || 'sobres');
        var txtU = (q > 1) ? (caj + ' ' + (DATA.copy.unitsBoxN || 'cajas') + ' · ' + sobTxt) : sobTxt;
        if (route === 'sub' && planId) txtU += ' · ' + (DATA.copy.everyWord || 'cada') + ' ' + planLabel(planId);
        unitsEl.textContent = txtU;
        /* el (i) dice la frecuencia de ESTA tarjeta */
        var tipT = card.querySelector('[data-nw-tip-tpl]');
        if (tipT) tipT.textContent = tipT.getAttribute('data-nw-tip-tpl').replace('{frecuencia}', planLabel(planId));
      }
      if (priceEl) priceEl.textContent = priceTxt || '';
      if (cmpEl) {
        cmpEl.textContent = cmpTxt;
        cmpEl.hidden = !cmpTxt;
      }
      if (perEl) perEl.textContent = perTxt || '';
      if (saveEl) {
        saveEl.textContent = saveTxt;
        saveEl.hidden = !saveTxt;
      }
      /* Qué recibes de verdad con la frecuencia elegida ("90 sobres cada 3 meses"): con el mapa
         frecuencia→variante la cantidad cambia, y sin esta línea el cliente no la vería. */
      var qtyEl = card.querySelector('[data-nw-sub-qty]');
      if (qtyEl) {
        var txt = '';
        if (pd && pd.qty && DATA.copy.subQtyNote) {
          var fl = planLabel(planId);
          txt = DATA.copy.subQtyNote.replace('{cantidad}', pd.qty).replace('{frecuencia}', fl);
        }
        qtyEl.textContent = txt;
        qtyEl.hidden = !txt;
      }
      /* el pack lleva su propio badge ("1 caja gratis", Juan 2-oct) en vez del % de ahorro */
      if (saveEl && route === 'sub') {
        var bTxt = (cb === '4') ? DATA.copy.packBadge : DATA.copy.subBadge;
        saveEl.textContent = bTxt || '';
        saveEl.hidden = !bTxt;
      }
      card.classList.toggle('is-selected', isActive);
      if (radio && isActive && !radio.disabled) radio.checked = true;
      /* frecuencia escrita en las tarjetas de suscripción que NO tienen el desplegable */
      var st = card.querySelector('[data-nw-freq-static]');
      if (st) {
        var lbl = planLabel(planId);
        st.innerHTML = '';
        if (DATA.copy.freqPrefix) st.appendChild(document.createTextNode(DATA.copy.freqPrefix + ' '));
        var bEl = document.createElement('b'); bEl.textContent = lbl; st.appendChild(bEl);
      }
    }

    /* El desplegable real es UNO: vive en la tarjeta de suscripción elegida. */
    function placeFreq() {
      if (!freqWrap) return;
      /* va a la tarjeta de suscripción del nº de cajas activo: con la compra única elegida
         (1 caja) vuelve a la de 1 caja, desactivado, como en la v2 */
      var target = null;
      routeCards.forEach(function (card) {
        if (card.getAttribute('data-route') === 'sub' && card.getAttribute('data-boxes') === S.boxes) target = card;
      });
      if (target) {
        var row = target.querySelector('.nw-pdp2__opt-row--sub');
        var st0 = target.querySelector('[data-nw-freq-static]');
        if (row && freqWrap.parentNode !== row) row.insertBefore(freqWrap, st0 || row.firstChild);
      }
      routeCards.forEach(function (card) {
        var st = card.querySelector('[data-nw-freq-static]');
        if (st) st.hidden = (freqWrap.parentNode === card.querySelector('.nw-pdp2__opt-row--sub'));
      });
    }

    function paintPackMix() {
      sec.setAttribute('data-nw-mix', S.mix ? '1' : '0');
      if (mixBtn) {
        mixBtn.textContent = S.mix ? (DATA.copy.packMixOff || 'Un solo sabor') : (DATA.copy.packMixOn || 'Mezclar sabores');
        mixBtn.setAttribute('aria-pressed', S.mix ? 'true' : 'false');
      }
      if (packFlavorsEl) {
        if (!S.mix) {
          packFlavorsEl.textContent = (DATA.copy.packFlavors || '4 × {sabor}').replace('{sabor}', labelOf(S.flavor));
        } else {
          var n = {}, order = [];
          S.slots.forEach(function (h) { if (!h) return; if (!n[h]) { n[h] = 0; order.push(h); } n[h]++; });
          packFlavorsEl.textContent = order.map(function (h) { return n[h] + ' ' + labelOf(h); }).join(' + ');
        }
      }
    }

    function paintBoxMetas() {
      /* El €/sobre de las tarjetas de nº de cajas sigue a la RUTA SELECCIONADA (S.route),
         no a una ruta fija. Antes se leía `DATA.boxesMetaRoute` (por defecto 'ot'), así que
         con la suscripción marcada —que es la opción por defecto— "1 caja" anunciaba
         1,26 €/sobre (el precio de compra única) en vez de 0,95 €, y no cambiaba al alternar
         entre suscripción y compra única. El setting `boxes_meta_route` sigue existiendo y
         ahora solo decide el valor del PRIMER pintado que hace Liquid (antes de que corra el
         JS); en cuanto el JS arranca, manda la ruta seleccionada. */
      var ref = S.route || 'ot';
      sec.querySelectorAll('[data-nw-box-meta]').forEach(function (el) {
        var nb = el.getAttribute('data-nw-box-meta');
        var perEl2 = el.querySelector('[data-nw-box-per]');
        if (!perEl2) return;
        /* El combo del pack ('4|ruta|*') lo escribe rebuildPackCombos() con su propio
           €/sobre (suma de los huecos 1-3 entre el total de sobres), así que aquí basta
           con leerlo: no hay que recalcular nada. */
        var c = DATA.combos[nb + '|' + ref + '|' + (nb === '4' ? '*' : S.flavor)];
        /* nº de sobres y €/sobre son dos elementos: en móvil van en dos filas */
        perEl2.textContent = (c && c.per) ? c.per : '';
      });
    }

    var freqPrimed = false, freqTouched = false, freqLastBoxes = null;
    function paintFreq() {
      if (!freqSel) return;
      var c = combo(S.boxes, 'sub');
      var opts = freqSel.options;
      var currentOk = false;
      for (var i = 0; i < opts.length; i++) {
        var ok = !!planData(c, opts[i].value);
        opts[i].disabled = !ok;
        if (ok && opts[i].value === freqSel.value) currentOk = true;
      }
      /* Se fuerza la frecuencia por defecto: (a) en el primer pintado (no fiarse del <option
         selected> del servidor), (b) si la elegida no vale para el combo activo, y (c) al cambiar
         de nº de cajas, porque 1 caja y el pack tienen defaults distintos — salvo que el usuario
         ya haya elegido frecuencia a mano, que entonces manda la suya. */
      var boxesChanged = (freqLastBoxes !== null && freqLastBoxes !== S.boxes);
      if (!currentOk || !freqPrimed || (boxesChanged && !freqTouched)) {
        var wanted = S.boxes === '4' ? DATA.defaultPlan4 : DATA.defaultPlan1;
        var picked = '';
        for (var j = 0; j < opts.length; j++) {
          if (!opts[j].disabled && opts[j].value === String(wanted)) { picked = opts[j].value; break; }
        }
        if (!picked) {
          for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { picked = opts[k].value; break; } }
        }
        if (picked) freqSel.value = picked;
      }
      freqPrimed = true;
      freqLastBoxes = S.boxes;
      freqSel.disabled = (S.route !== 'sub') || !comboHasPlans(c);
    }

    function paintSlots() {
      var isPack = S.boxes === '4';
      slotBtns.forEach(function (b, i) {
        var h = S.slots[i];
        b.setAttribute('data-flavor', h);
        var fl = b.querySelector('[data-nw-slot-flavor]');
        if (fl) {
          /* "Salty" en la primera línea y el sabor en la segunda: las 4 cajas a la misma altura */
          var txt = h ? labelOf(h) : (DATA.copy.slotEmpty || '');
          var sp = fl.querySelectorAll('span');
          if (sp.length >= 2) {
            var cut = h ? txt.indexOf(' ') : -1;
            sp[0].textContent = cut > 0 ? txt.slice(0, cut) : txt;
            sp[1].textContent = cut > 0 ? txt.slice(cut + 1) : '';
          } else { fl.textContent = txt; }
        }
        b.classList.toggle('is-empty', !h);
        /* sobre del sabor asignado */
        var th = b.querySelector('.nw-pdp2__slot-thumb');
        if (th) {
          var src = h ? ((DATA.flavors[h] || {}).thumb || '') : '';
          if (src) {
            if (th.getAttribute('src') !== src) th.setAttribute('src', src);
            th.hidden = false;
          } else {
            th.hidden = true;
          }
        }
        /* la X solo cuando hay algo que quitar */
        var cl = b.querySelector('[data-nw-slot-clear]');
        if (cl) cl.hidden = !h;
        var on = (+b.getAttribute('data-nw-slot') === S.activeSlot);
        b.classList.toggle('is-active', on);
        var hit = b.querySelector('[data-nw-slot-pick]');
        if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var complete = packComplete();
      propInputs.forEach(function (inp, i) {
        inp.disabled = !isPack || !complete;
        inp.value = S.slots[i] ? labelOf(S.slots[i]) : '';
      });
      if (propSummary) {
        propSummary.disabled = !isPack || !complete;
        propSummary.value = S.slots.map(function (h) { return h ? labelOf(h) : ''; }).join(' · ');
      }
      sec.setAttribute('data-nw-slot-active', String(S.activeSlot));
      if (flavorHeading) {
        var txt = (isPack && S.mix)
          ? (DATA.copy.flavorLabelPack || '').replace('{caja}', slotTitle(S.activeSlot))
          : (DATA.copy.flavorLabel || '');
        flavorHeading.textContent = txt;
      }
    }
    function slotTitle(n) {
      var b = sec.querySelector('[data-nw-slot="' + n + '"] .nw-pdp2__slot-name');
      return b ? b.textContent.trim() : (((DATA.copy && DATA.copy.boxWord) || 'Caja') + ' ' + n);
    }

    function paintFlavors() {
      /* con el pack, "activo" = el sabor del hueco que se está editando (el acento de la ficha
         NO cambia: el pack es una mezcla, no un sabor). Con 1 caja, el sabor de la ficha. */
      var marked = (S.boxes === '4') ? S.slots[S.activeSlot - 1] : S.flavor;
      flavorCards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-flavor') === marked);
      });
      if (flavorLabelEl) flavorLabelEl.textContent = labelOf(S.flavor);
      var f = DATA.flavors[S.flavor];
      if (f) {
        if (f.accent) sec.style.setProperty('--nw-accent', f.accent);
        if (f.cardFill) sec.style.setProperty('--nw-card-fill', f.cardFill);
      }
    }

    /* Detalles e Ingredientes viajan con el sabor: el selector hace swap sin recargar, así que
       si no se reescriben aquí la ficha de Watermelon se queda con la declaración del limón.
       Con el pack (mezcla de 4 cajas) no hay un sabor único: manda el texto *_pack si lo hay. */
    function paintAccordions() {
      if (!accBodies.length) return;
      var f = DATA.flavors[S.flavor] || {};
      var isPack = S.boxes === '4';
      var bodies = {
        '0': (isPack && DATA.copy.acc1Pack) ? DATA.copy.acc1Pack : f.acc1,
        '1': (isPack && DATA.copy.acc2Pack) ? DATA.copy.acc2Pack : f.acc2
      };
      accBodies.forEach(function (el) {
        var html = bodies[el.getAttribute('data-nw-acc-body')];
        if (html) el.innerHTML = html;
      });
    }

    function syncFloatPrice() {
      if (!floatPriceEl) return;
      var card = sec.querySelector('[data-nw-route-card].is-selected') || routeCards[0];
      if (!card) return;
      var now = card.querySelector('[data-nw-price]');
      var was = card.querySelector('[data-nw-compare]');
      var html = now ? now.textContent.trim() : '';
      if (was && !was.hidden && was.textContent.trim()) html += ' <s>' + was.textContent.trim() + '</s>';
      floatPriceEl.innerHTML = html;
    }

    /* Difusión del sabor activo al resto de la página.
       Otras secciones (Solo lo esencial, Tabla comparativa) escuchan este evento para
       enseñar el sobre del sabor elegido sin recargar. Se emite solo cuando cambia, y
       lleva el handle + la etiqueta + el acento del bloque, que es todo lo que necesitan.
       Fuera de la ficha (la home no monta esta sección) nadie lo emite y no pasa nada. */
    var lastBroadcast = '';
    function broadcastFlavor() {
      /* con el pack el sabor de la ficha no cambia (es una mezcla): manda el del hueco
         que se está previsualizando, y si no hay ninguno, el primero de la lista */
      var h = S.flavor;
      if (S.boxes === '4') {
        h = S.slots[S.activeSlot - 1] || S.slots.filter(Boolean)[0] || S.flavor;
      }
      if (!h || h === lastBroadcast) return;
      lastBroadcast = h;
      var f = DATA.flavors[h] || {};
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: f.label || '', accent: f.accent || '' }
        }));
      } catch (e) { /* navegador sin CustomEvent: la página se queda con el sabor de partida */ }
    }

    function paint() {
      /* test de la caja: sin "Mezclar sabores", las 4 cajas del pack son del sabor elegido */
      if (!S.mix) { for (var si = 0; si < 4; si++) S.slots[si] = S.flavor; }
      /* primero los combos sintéticos del pack: ensureRoute y todo el pintado los leen */
      rebuildPackCombos();
      ensureRoute();
      sec.setAttribute('data-nw-boxes', S.boxes);
      sec.setAttribute('data-nw-route', S.route);
      sec.setAttribute('data-nw-flavor', S.flavor);
      boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-boxes') === S.boxes);
        var r = card.querySelector('input[type=radio]');
        if (r && card.getAttribute('data-boxes') === S.boxes) r.checked = true;
      });
      paintSlots();
      paintFlavors();
      paintAccordions();
      paintFreq();
      routeCards.forEach(paintRouteCard);
      placeFreq();
      paintPackMix();
      paintBoxMetas();

      /* `v` solo decide si el botón se puede pulsar: con el pack vale 'multi' (las líneas las
         arma buildItems). El input `id` se alimenta SIEMPRE con la caja de 1, que es lo único
         que sabría enviar un submit nativo si el JS no llegara a cargar. */
      var v = variantFor(S.boxes, S.route);
      var incomplete = (S.boxes === '4') && !packComplete();
      var c1id = combo('1', S.route);
      if (idInput && c1id && c1id.variant) idInput.value = c1id.variant;
      if (addBtn) {
        addBtn.disabled = !v || incomplete;
        addBtn.textContent = incomplete
          ? (DATA.copy.incomplete || 'Elige los 4 sabores')
          : (v ? (DATA.copy.addLabel || addBtn.textContent) : (DATA.copy.unavailable || 'No disponible'));
      }
      /* Aviso de las cajas gratis: sin él, ver 4 cajas al precio de 3 parece un error.
         OJO: `q` hay que declararla AQUI. Sin declararla no daba error pero resolvia al input de
         busqueda del tema (que tiene id="q") por el espacio global de window, groupBoxes recibia
         un elemento del DOM, salia NaN y el aviso no se mostraba nunca, sin rastro en consola. */
      var freeEl = sec.querySelector('[data-nw-free-note]');
      if (freeEl) {
        var q = currentQty();
        var gr2 = groupBoxes(q);
        var txt2 = '';
        if (S.boxes === '1' && gr2.packs > 0 && DATA.copy.freeNote) {
          txt2 = DATA.copy.freeNote.replace('{cajas}', q).replace('{pagas}', gr2.payable).replace('{gratis}', gr2.packs);
        }
        freeEl.textContent = txt2;
        freeEl.hidden = !txt2;
      }
      if (boxNoteEl) {
        var note = (S.boxes === '4' && DATA.copy.boxNotePack) ? DATA.copy.boxNotePack : DATA.copy.boxNote;
        if (note) boxNoteEl.innerHTML = note;
      }
      showError('');
      syncFloatPrice();
      broadcastFlavor();
    }

    /* ---------- listeners ---------- */
    boxCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        S.boxes = card.getAttribute('data-boxes');
        if (S.boxes === '4') S.activeSlot = 1;
        paint();
      });
    });

    routeCards.forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var nb = card.getAttribute('data-boxes');
        if (nb && nb !== S.boxes) {
          /* cada tarjeta recuerda su frecuencia; si no se tocó, vuelve a su valor por defecto */
          if (freqSel) {
            var keep = S.freqBy[nb];
            freqTouched = !!keep;
            if (keep) freqSel.value = keep;
          }
          S.boxes = nb;
          if (nb === '4') S.activeSlot = 1; else S.mix = false;
        }
        S.route = card.getAttribute('data-route');
        paint();
      });
    });

    if (freqSel) {
      freqSel.addEventListener('change', function () {
        freqTouched = true;
        S.freqBy[S.boxes] = freqSel.value;
        var subRadio = sec.querySelector('[data-nw-route-card][data-route="sub"] input[type=radio]');
        if (subRadio && !subRadio.disabled && !subRadio.checked) { subRadio.checked = true; S.route = 'sub'; }
        paint();
      });
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.getAttribute('data-available') !== '1') { e.preventDefault(); return; }
        var h = card.getAttribute('data-flavor');
        if (S.boxes === '4' && !S.mix) {
          /* test de la caja: pack de un solo sabor, el sabor cambia las 4 cajas */
          e.preventDefault();
          S.flavor = h;
          applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        if (S.boxes === '4') {
          /* pack: asigna el sabor al hueco activo y avanza al siguiente */
          e.preventDefault();
          var idx = S.activeSlot - 1;
          S.slots[idx] = h;
          var justSet = sec.querySelector('[data-nw-slot="' + S.activeSlot + '"]');
          if (justSet) {
            justSet.classList.remove('is-just-set');
            void justSet.offsetWidth;
            justSet.classList.add('is-just-set');
          }
          if (slotsLive) slotsLive.textContent = slotTitle(S.activeSlot) + ': ' + labelOf(h);
          S.activeSlot = nextEmptySlot((S.activeSlot % 4) + 1);
          /* la galería previsualiza el sabor recién asignado, pero el acento de la ficha
             no se toca (el pack es una mezcla; recolorearlo todo no aporta y contradice el diseño) */
          if (DATA.packFollowFlavor) applyGallery((DATA.flavors[h] || {}).gallery);
          paint();
          return;
        }
        /* 1 caja: cambia el sabor de la ficha in-situ (o navega si flavor_mode = navigate) */
        var href = card.getAttribute('data-href');
        if (sec.getAttribute('data-nw-flavor-mode') === 'navigate' && href) return;
        e.preventDefault();
        S.flavor = h;
        applyGallery((DATA.flavors[h] || {}).gallery);
        paint();
      });
    });

    if (mixBtn) {
      mixBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var packRadio = sec.querySelector('.nw-pdp2__opt--pack input[type=radio]');
        if (S.boxes !== '4' || S.route !== 'sub') {
          /* si el pack no estaba elegido, se elige y se abre la mezcla de una vez */
          if (packRadio && !packRadio.disabled) { packRadio.checked = true; packRadio.dispatchEvent(new Event('change')); }
          S.mix = true;
        } else {
          S.mix = !S.mix;
        }
        S.activeSlot = 1;
        paint();
        if (S.mix && slotsEl && slotsEl.scrollIntoView) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          slotsEl.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }

    slotBtns.forEach(function (b) {
      var n = +b.getAttribute('data-nw-slot');
      var hit = b.querySelector('[data-nw-slot-pick]');
      if (hit) {
        hit.addEventListener('click', function () {
          S.activeSlot = n;
          paintSlots();
          paintFlavors();   /* el sabor marcado es el del hueco activo: si no, queda el anterior */
          /* y la galería muestra las imágenes de ESE sabor (si el hueco ya tiene uno) */
          var hSlot = S.slots[n - 1];
          if (hSlot && DATA.packFollowFlavor) applyGallery((DATA.flavors[hSlot] || {}).gallery);
          broadcastFlavor();   /* aquí no pasa por paint(): avisa a mano al resto de la página */
        });
      }
      var clear = b.querySelector('[data-nw-slot-clear]');
      if (clear) {
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          S.slots[n - 1] = '';
          S.activeSlot = n;   /* queda listo para volver a elegir */
          if (slotsLive) slotsLive.textContent = slotTitle(n) + ': ' + (DATA.copy.slotEmpty || '');
          paint();            /* paint y no paintSlots: vuelve a bloquear el botón de comprar */
        });
      }
    });

    /* ---------- tooltip de información ---------- */
    /* test de la caja: hay un (i) en cada tarjeta de suscripción, no uno solo */
    sec.querySelectorAll('[data-nw-info-wrap]').forEach(function (infoWrap) {
      var infoBtn = infoWrap.querySelector('[data-nw-info]');
      if (!infoBtn) return;
      /* El globo se ancla al icono, que en móvil cae a media tarjeta: sin acotarlo se sale por la
         derecha. Se mide y se desplaza con --nw-tip-dx, y la flechita se compensa para seguir
         apuntando al icono. */
      var tipEl = infoWrap.querySelector('.nw-pdp2__tip');
      function clampTip() {
        if (!tipEl) return;
        tipEl.style.setProperty('--nw-tip-dx', '0px');
        tipEl.style.setProperty('--nw-tip-arrow-dx', '0px');
        var r = tipEl.getBoundingClientRect();
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var m = 10, dx = 0;
        if (r.right > vw - m) dx = -(r.right - (vw - m));
        if (r.left + dx < m) dx = m - r.left;
        dx = Math.round(dx);
        tipEl.style.setProperty('--nw-tip-dx', dx + 'px');
        var arrow = Math.max(10 - 18, Math.min(-dx, r.width - 22 - 18));
        tipEl.style.setProperty('--nw-tip-arrow-dx', Math.round(arrow) + 'px');
      }
      infoWrap.addEventListener('mouseenter', clampTip);
      window.addEventListener('resize', function () {
        if (infoWrap.classList.contains('is-open')) clampTip();
      }, { passive: true });
      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = infoWrap.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) clampTip();
      });
      document.addEventListener('click', function (e) {
        if (!infoWrap.contains(e.target)) {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          infoWrap.classList.remove('is-open');
          infoBtn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* ---------- contador ---------- */
    function clampQty() {
      if (!qtyInput) return;
      var max = DATA.maxQty || 10;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
    }
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = +b.getAttribute('data-step');
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + d;
        clampQty();
        paint();   /* el precio mostrado es el total: hay que repintarlo */
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (/[^0-9]/.test(qtyInput.value)) qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
        /* LIT: tope ya al teclear; antes 15 enseñaba 340,20 hasta salir del campo y luego cobraba 10 */
        var maxQ = DATA.maxQty || 10;
        if (parseInt(qtyInput.value, 10) > maxQ) qtyInput.value = maxQ;
        paint();
      });
      qtyInput.addEventListener('blur', function () { clampQty(); paint(); });
    }

    /* ---------- add to cart ---------- */
    var busy = false;
    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      /* LIT: propaga el query string (UTM, oppref, gclid...) al destino.
         Antes: navegacion dura a '/checkout' que descartaba los parametros,
         causando que las ventas de paid cayeran en direct/unknown.
         Se usa root tambien en checkout para no salir del locale (/en/). */
      var qs = window.location.search || '';
      var dest = (mode === 'cart') ? (root + 'cart') : (root + 'checkout');
      window.location.href = dest + qs;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        clampQty();
        if (S.boxes === '4' && !packComplete()) {
          showError(DATA.copy.incomplete || 'Elige el sabor de las 4 cajas.');
          return;
        }
        var itemsAdd = buildItems();
        if (!itemsAdd) { showError(DATA.copy.unavailable || 'No disponible'); return; }
        busy = true;
        showError('');
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }
        /* Siempre payload JSON multi-línea: hasta el caso más simple puede ser más de una línea
           (4 cajas de un sabor = 3 de pago + 1 de regalo), y así hay UN solo camino que probar
           en vez de dos. El precio que se cobra es la suma de las líneas de pago, que es
           exactamente el que muestra la tarjeta. */
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var body = JSON.stringify(DATA.afterAdd === 'drawer'
          ? { items: itemsAdd, sections: 'cart-drawer' }
          : { items: itemsAdd });
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        /* LIT (2026-10-06): lo elegido aquí SUSTITUYE a las cajas LIT que ya hubiera en el carrito.
           Antes se acumulaba (volver atrás desde el checkout y añadir otra vez): 1 caja + 3 cajas
           quedaban como SL30 x4 = 113,40 en vez del pack de 85,05. Mismas cajas, mismo precio.
           Si leer o vaciar el carrito falla, se añade igual: nunca bloqueamos la compra. */
        var litBox = /^lit-daily-hydration|^lit-pack-4-cajas/;
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var upd = {}, n = 0;
            ((cart && cart.items) || []).forEach(function (it) {
              if (it && litBox.test(String(it.handle || ''))) { upd[it.key] = 0; n++; }
            });
            if (!n) return null;
            return fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ updates: upd }) });
          })
          .catch(function () { return null; })
          .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: headers }); })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.soft = true;
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            /* El submit nativo solo sabe enviar UNA línea, así que no sirve de fallback para un
               payload de varias: cualquier fallo (422 del carrito o caída de red) se informa
               en línea, que además es mejor UX que aterrizar en una página de error de Shopify. */
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- bfcache: liberar la guarda al volver ATRÁS ----------
       `busy` se pone a true al enviar y solo se libera en el catch o en los modos
       drawer/stay. Con after_add = 'checkout' la página navega y busy se queda en true.
       Al volver atrás, el navegador restaura la página desde bfcache con el JS intacto
       (no se re-ejecuta la sección), así que el submit salía por `if (busy) return;` y
       el botón no respondía hasta refrescar. Reportado por Juan el 2026-09-23:
       "si le doy a Suscripción, añado al carrito, vuelvo a la landing, le doy a Compra
       única e intento añadir al carrito, no me funciona, tengo que refrescar".
       Afecta a las 11 plantillas que montan esta sección, todas con after_add=checkout. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;          /* carga normal: la sección ya arranca limpia */
      busy = false;
      if (addBtn) {
        addBtn.classList.remove('is-added');
        addBtn.textContent = DATA.copy.addLabel || addBtn.textContent;
      }
      showError('');
    });

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA desde la barra flotante (Juan, 2026-09-15), SOLO EN LANDINGS.
           Antes solo hacia scroll a la ficha y el usuario tenia que volver a pulsar
           "Agregar al carrito": dos pasos para la misma intencion, en el 85% del trafico
           que es movil.

           ACOTADO a `body.template-landing-page` a peticion de Juan: la PDP y la pagina
           de afiliados usan el layout por defecto (sin esa clase) y conservan el
           comportamiento de siempre. Esta seccion la comparten 12 plantillas.

           Se dispara el MISMO submit del formulario, no una copia de la logica: asi la
           barra hereda gratis la validacion de stock, el precio correcto segun ruta
           (suscripcion / compra unica), el manejo de errores y el destino de `after_add`.

           UNICA excepcion dentro de las landings: el pack de 4 cajas exige elegir los 4
           sabores. Si aun no estan, mandar el submit solo pintaria un error fuera de
           pantalla, asi que ahi se lleva a la ficha, que es donde se eligen.

           PDP (Juan, 2026-10-02): la ficha de producto pasa a comprar directo igual que
           la landing. Se activa por plantilla con el ajuste `float_direct_add`, encendido
           en product.out-of-stock-preventa.json (la plantilla que usan, pese al nombre,
           las 6 fichas de LIT Daily Hydration). No va por clase del body: asi afiliados
           sigue llevando a la ficha.
           Si el boton real esta desactivado ("No disponible"), el submit no haria nada
           visible: tambien se lleva a la ficha, que es donde se ve el motivo. */
        var esLanding = document.body.classList.contains('template-landing-page');
        var directAdd = esLanding || (floatBar && floatBar.getAttribute('data-direct') === '1');
        var needsFlavors = (S.boxes === '4' && !packComplete());
        var addBlocked = !!(addBtn && addBtn.disabled);

        var fbMode = (directAdd && form && !needsFlavors && !addBlocked) ? 'compra' : 'scroll';
        /* Rastro de la barra flotante (Kiko, 2026-10-02): GTM lo manda a GA4 como `floatbar_click`
           con floatbar_mode (compra | scroll) y floatbar_page, para saber qué parte del carrito
           viene de la barra. */
        try {
          (window.dataLayer = window.dataLayer || []).push({ event: 'floatbar_click', floatbar_mode: fbMode, floatbar_page: window.location.pathname });
        } catch (e) { /* sin dataLayer la barra sigue funcionando */ }

        if (fbMode === 'compra') {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            /* Safari viejo no tiene requestSubmit: dispatch manual del mismo evento. */
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          return;
        }

        var ficha = document.getElementById('ficha');
        if (ficha) {
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ficha.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && 'IntersectionObserver' in window) {
      var fbEarly = floatBar.getAttribute('data-early') === '1';
      if (fbEarly) {
        var fbUpdate = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          /* Barra flotante movil (Juan, 2026-09-09): visible NADA MAS PASAR EL HERO y
             sin interrupciones.
             Antes: vis = (scrollY > vh * 0.82) && !fichaVisible
               - el 0.82 la hacia esperar casi un viewport entero, se sentia lenta
               - el !fichaVisible la ocultaba en cuanto la ficha entraba en pantalla, y
                 al seguir bajando volvia a salir: era el "se va cortando"
             Ahora: aparece al 55% del viewport (el hero mide 100svh, asi que ya se ha
             empezado a salir) y NO se oculta por la ficha. Solo se retira cuando el
             boton de compra real esta a la vista, para no duplicar el mismo CTA. */
          /* SIN excepciones: Juan la quiere visible TODO EL RATO nada mas pasar el hero.
             Se probo ocultarla mientras el boton real de compra estaba a la vista, para no
             duplicar el CTA, pero eso reintroducia el corte que se queria eliminar (medido:
             desaparecia a 3.0x de viewport y volvia a 4.0x). Asi que se queda fija. */
          var vis = window.scrollY > vh * 0.55;
          floatBar.classList.toggle('is-visible', vis);
          liftWA(vis);
        };
        var bio = new IntersectionObserver(function () { fbUpdate(); }, { threshold: 0 });
        bio.observe(sec);
        window.addEventListener('scroll', fbUpdate, { passive: true });
        window.addEventListener('resize', fbUpdate, { passive: true });
        fbUpdate();
      } else if (addBtn) {
        var fio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var vis = !e.isIntersecting && e.boundingClientRect.top < 0;
            floatBar.classList.toggle('is-visible', vis);
            liftWA(vis);
          });
        }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
        fio.observe(addBtn);
      }
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-nw-pdp2t]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-discovery-bak-20261002"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPddInit) return;
  window.__nwPddInit = true;

  function dl(ev, params) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, params || {})); } catch (e) {}
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdd-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) {} }
    DATA.copy = DATA.copy || {};
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var lp = sec.getAttribute('data-lp') || '';
    var lpVar = sec.getAttribute('data-lp-variant') || '';

    /* ---------- reveal (observer propio: sin él los data-reveal se quedan a opacidad 0) ---------- */
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- «gratis» de la oferta, SIEMPRE con el subrayado (Juan, ronda 5): en la frase del hero y en el cierre.
       La palabra sigue en el ajuste (se edita en el Theme Editor); aquí solo se envuelve en .nw-pdd-hl, con espacio
       duro delante para que no se quede sola. "Envío gratis" no se toca: es otra cosa. Sin JS se ve igual, sin subrayar. */
    function markGratis(el) {
      if (!el || el.querySelector('.nw-pdd-hl')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(/(te sale)\s(gratis)/i);
        if (!m) continue;
        var word = node.splitText(m.index + m[1].length + 1);
        node.nodeValue = node.nodeValue.slice(0, -1) + '\u00a0';
        word.splitText(m[2].length);
        var hl = document.createElement('span'); hl.className = 'nw-pdd-hl'; hl.textContent = word.nodeValue;
        word.parentNode.replaceChild(hl, word);
        return;
      }
    }
    /* la frase del hero en dos líneas: "Conoce nuestro Discovery Set." / "Si te suscribes, te sale gratis." */
    var heroNote = document.querySelector('.nw-herob__note');
    if (heroNote && !heroNote.querySelector('br') && heroNote.firstChild && heroNote.firstChild.nodeType === 3) {
      var cut = heroNote.firstChild.nodeValue.indexOf('. ');
      if (cut > 0) {
        var second = heroNote.firstChild.splitText(cut + 1);
        second.nodeValue = second.nodeValue.replace(/^\s+/, '');
        heroNote.insertBefore(document.createElement('br'), second);
      }
    }
    [heroNote].concat([].slice.call(document.querySelectorAll('.nw-cta-club__sub'))).forEach(markGratis);

    /* ---------- galería ---------- */
    var stage = sec.querySelector('[data-nw-pdd-stage]');
    var slides = sec.querySelectorAll('.nw-pdd__slide');
    var current = 0;
    function goTo(i, smooth) {
      if (!stage || !slides.length) return;
      var n = slides.length;
      i = ((i % n) + n) % n;
      stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: (smooth && !reduced) ? 'smooth' : 'auto' });
      current = i;
    }
    function nearest() {
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, idx) {
        var d = Math.abs(s.offsetLeft - stage.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < bd) { bd = d; best = idx; }
      });
      return best;
    }
    sec.querySelectorAll('[data-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(current + (+b.getAttribute('data-nav')), true); });
    });

    /* ---------- sobres: miniaturas + nw:flavor ---------- */
    var flavors = Array.prototype.slice.call(sec.querySelectorAll('.nw-pdd__flavor'));
    var lastFlavor = '';
    var touched = false;
    function broadcast(btn) {
      if (!btn) return;
      var h = btn.getAttribute('data-flavor');
      if (!h || h === lastFlavor) return;
      lastFlavor = h;
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: btn.getAttribute('data-label') || '', accent: btn.getAttribute('data-accent') || '' }
        }));
      } catch (e) {}
    }
    function setActiveFlavor(btn) {
      flavors.forEach(function (f) { f.classList.toggle('is-active', f === btn); });
    }
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('.nw-pdd__thumb'));
    function markThumb(i) {
      thumbs.forEach(function (t) { var on = +t.getAttribute('data-thumb') === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function flavorForSlide(i) { var m = null; flavors.forEach(function (f) { if (+f.getAttribute('data-slide') === i) m = f; }); return m; }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        goTo(i, true); markThumb(i);
        var f = flavorForSlide(i);
        setActiveFlavor(f);
        if (f) { touched = true; broadcast(f); dl('lp_flavor_view', { lp_id: lp, lp_variant: lpVar, flavor: f.getAttribute('data-label'), trigger: 'thumb' }); }
      });
    });
    if (stage) {
      var tick = false;
      stage.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var i = nearest();
          if (i === current) return;
          current = i;
          markThumb(i);
          var match = flavorForSlide(i);
          setActiveFlavor(match);
          if (match) { touched = true; broadcast(match); }
        });
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
      });
    }

    /* Rotación de sabores (Lemon -> Peach -> Watermelon) mientras la sección destino está en pantalla y nadie ha
       tocado un sobre: la tabla en L1; "Solo lo esencial" en el test (Juan: cada 2 s, amarillo -> naranja -> rojo) */
    if (sec.getAttribute('data-cycle') === '1' && flavors.length > 1 && !reduced && 'IntersectionObserver' in window) {
      var tabla = null;
      try { tabla = document.querySelector(sec.getAttribute('data-cycle-target') || '.nw-tabla'); } catch (e) {}
      var cycleMs = Math.max(1200, parseInt(sec.getAttribute('data-cycle-ms'), 10) || 2400);
      /* con el cursor encima de los sobres la rotación se para, y sigue al salir (Juan, ronda 7) */
      var hoverPaused = false, pauseSel = sec.getAttribute('data-cycle-pause');
      if (pauseSel) {
        try {
          document.querySelectorAll(pauseSel).forEach(function (el) {
            el.addEventListener('mouseenter', function () { hoverPaused = true; });
            el.addEventListener('mouseleave', function () { hoverPaused = false; });
          });
        } catch (e) {}
      }
      if (tabla) {
        var ci = 0, timer = null;
        var step = function () {
          if (touched) { clearInterval(timer); timer = null; return; }
          if (hoverPaused) return;
          broadcast(flavors[ci % flavors.length]);
          ci++;
        };
        var tio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !touched && !timer) { step(); timer = setInterval(step, cycleMs); }
            if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.35 });
        tio.observe(tabla);
      }
    }

    /* ---------- compra: 1 unidad, UTM conservados ---------- */
    var form = sec.querySelector('[data-nw-pdd-form]');
    var addBtn = sec.querySelector('[data-nw-pdd-add]');
    var errEl = sec.querySelector('[data-nw-pdd-error]');
    var busy = false;
    function showError(msg) { if (errEl) { errEl.textContent = msg || ''; errEl.hidden = !msg; } }
    function jfetch(url, body) {
      var opts = { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } };
      if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
      return fetch(root + url, opts).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) { var e = new Error('cart'); e.desc = j && (j.description || j.message); throw e; } return j; });
      });
    }
    function buy(source) {
      if (busy || !DATA.variant || (addBtn && addBtn.disabled)) return;
      busy = true;
      showError('');
      var original = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = DATA.copy.added || 'Vamos al pago…'; }
      dl('lp_add', { lp_id: lp, lp_variant: lpVar, source: source || 'ficha' });
      var vid = Number(DATA.variant);
      jfetch('cart.js')
        .then(function (cart) {
          var line = (cart.items || []).filter(function (it) { return it.variant_id === vid; })[0];
          if (!line) return jfetch('cart/add.js', { items: [{ id: vid, quantity: 1 }] });
          if (line.quantity !== 1) return jfetch('cart/change.js', { id: line.key, quantity: 1 });
          return null;
        })
        .then(function () {
          var attrs = {};
          if (lp) attrs.Landing = lp;
          if (lpVar) attrs.Variante = lpVar;
          if (!Object.keys(attrs).length) return null;
          return jfetch('cart/update.js', { attributes: attrs }).catch(function () { return null; });
        })
        .then(function () {
          var mode = DATA.afterAdd || 'checkout';
          var qs = window.location.search || '';
          window.location.href = ((mode === 'cart') ? (root + 'cart') : (root + 'checkout')) + qs;
        })
        .catch(function (err) {
          busy = false;
          if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
          showError((err && err.desc) || DATA.copy.error || 'No hemos podido añadirlo.');
        });
    }
    if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); buy('ficha'); });

    /* bfcache: al volver ATRÁS desde el checkout el JS no se re-ejecuta y busy seguía a true */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      busy = false;
      if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.add || addBtn.textContent; }
      showError('');
    });

    /* Enlaces que tienen que llevarse los UTM (agotado → landing base) */
    sec.querySelectorAll('[data-nw-keep-qs]').forEach(function (a) {
      var qs = window.location.search || '';
      if (!qs) return;
      try { var u = new URL(a.getAttribute('href'), window.location.origin); u.search = qs; a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {}
    });

    /* ---------- barra flotante: compra directa desde el 55% del viewport ---------- */
    var floatBar = sec.querySelector('[data-nw-pdd-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-pdd-floatbtn]');
    if (floatBtn) floatBtn.addEventListener('click', function () { buy('floatbar'); });
    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar) {
      var esLanding = document.body.classList.contains('template-landing-page');
      var shown = null, fbTick = false;
      var fbUpdate = function () {
        fbTick = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vis = esLanding ? (window.scrollY > vh * 0.55)
                            : (window.matchMedia('(max-width: 767px)').matches && addBtn && addBtn.getBoundingClientRect().bottom < 0);
        if (vis === shown) return;
        shown = vis;
        floatBar.classList.toggle('is-visible', !!vis);
        floatBar.setAttribute('aria-hidden', vis ? 'false' : 'true');
        if (floatBtn) floatBtn.tabIndex = vis ? 0 : -1;
        liftWA(vis);
      };
      var fbQueue = function () { if (!fbTick) { fbTick = true; requestAnimationFrame(fbUpdate); } };
      window.addEventListener('scroll', fbQueue, { passive: true });
      window.addEventListener('resize', fbQueue, { passive: true });
      fbUpdate();
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    /* ---------- medición: CTAs de toda la página que llevan a esta ficha ---------- */
    var anchorEl = sec.querySelector('.nw-pdd__anchor');
    var anchorId = anchorEl ? anchorEl.id : 'ficha';
    if (!window.__nwPddCta) {
      window.__nwPddCta = true;
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href$="#' + anchorId + '"]') : null;
        if (!a) return;
        var s = a.closest('.shopify-section');
        var loc = s && s.id ? s.id.replace(/^shopify-section-(template--\d+__)?/, '') : 'otro';
        dl('lp_cta_click', { lp_id: lp, lp_variant: lpVar, location: loc });
      }, true);
      sec.querySelectorAll('.nw-pdd__acc').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) dl('lp_acc_open', { lp_id: lp, lp_variant: lpVar, acc: (d.querySelector('.nw-pdd__acc-title') || {}).textContent || '' });
        });
      });
      dl('lp_view', { lp_id: lp, lp_variant: lpVar });
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pdd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-discovery"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPddInit) return;
  window.__nwPddInit = true;

  function dl(ev, params) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, params || {})); } catch (e) {}
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdd-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) {} }
    DATA.copy = DATA.copy || {};
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var lp = sec.getAttribute('data-lp') || '';
    var lpVar = sec.getAttribute('data-lp-variant') || '';

    /* ---------- reveal (observer propio: sin él los data-reveal se quedan a opacidad 0) ---------- */
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.05 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- «gratis» de la oferta, SIEMPRE con el subrayado (Juan, ronda 5): en la frase del hero y en el cierre.
       La palabra sigue en el ajuste (se edita en el Theme Editor); aquí solo se envuelve en .nw-pdd-hl, con espacio
       duro delante para que no se quede sola. "Envío gratis" no se toca: es otra cosa. Sin JS se ve igual, sin subrayar. */
    function markGratis(el) {
      if (!el || el.querySelector('.nw-pdd-hl')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(/(te sale)\s(gratis)/i);
        if (!m) continue;
        var word = node.splitText(m.index + m[1].length + 1);
        node.nodeValue = node.nodeValue.slice(0, -1) + '\u00a0';
        word.splitText(m[2].length);
        var hl = document.createElement('span'); hl.className = 'nw-pdd-hl'; hl.textContent = word.nodeValue;
        word.parentNode.replaceChild(hl, word);
        return;
      }
    }
    /* la frase del hero en dos líneas: "Conoce nuestro Discovery Set." / "Si te suscribes, te sale gratis." */
    var heroNote = document.querySelector('.nw-herob__note');
    if (heroNote && !heroNote.querySelector('br') && heroNote.firstChild && heroNote.firstChild.nodeType === 3) {
      var cut = heroNote.firstChild.nodeValue.indexOf('. ');
      if (cut > 0) {
        var second = heroNote.firstChild.splitText(cut + 1);
        second.nodeValue = second.nodeValue.replace(/^\s+/, '');
        heroNote.insertBefore(document.createElement('br'), second);
      }
    }
    [heroNote].concat([].slice.call(document.querySelectorAll('.nw-cta-club__sub'))).forEach(markGratis);

    /* ---------- galería ---------- */
    var stage = sec.querySelector('[data-nw-pdd-stage]');
    var slides = sec.querySelectorAll('.nw-pdd__slide');
    var current = 0;
    function goTo(i, smooth) {
      if (!stage || !slides.length) return;
      var n = slides.length;
      i = ((i % n) + n) % n;
      stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: (smooth && !reduced) ? 'smooth' : 'auto' });
      current = i;
    }
    function nearest() {
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, idx) {
        var d = Math.abs(s.offsetLeft - stage.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < bd) { bd = d; best = idx; }
      });
      return best;
    }
    sec.querySelectorAll('[data-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(current + (+b.getAttribute('data-nav')), true); });
    });

    /* ---------- sobres: miniaturas + nw:flavor ---------- */
    var flavors = Array.prototype.slice.call(sec.querySelectorAll('.nw-pdd__flavor'));
    var lastFlavor = '';
    var touched = false;
    function broadcast(btn) {
      if (!btn) return;
      var h = btn.getAttribute('data-flavor');
      if (!h || h === lastFlavor) return;
      lastFlavor = h;
      try {
        document.dispatchEvent(new CustomEvent('nw:flavor', {
          detail: { handle: h, label: btn.getAttribute('data-label') || '', accent: btn.getAttribute('data-accent') || '' }
        }));
      } catch (e) {}
    }
    function setActiveFlavor(btn) {
      flavors.forEach(function (f) { f.classList.toggle('is-active', f === btn); });
    }
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('.nw-pdd__thumb'));
    function markThumb(i) {
      thumbs.forEach(function (t) { var on = +t.getAttribute('data-thumb') === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function flavorForSlide(i) { var m = null; flavors.forEach(function (f) { if (+f.getAttribute('data-slide') === i) m = f; }); return m; }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        goTo(i, true); markThumb(i);
        var f = flavorForSlide(i);
        setActiveFlavor(f);
        if (f) { touched = true; broadcast(f); dl('lp_flavor_view', { lp_id: lp, lp_variant: lpVar, flavor: f.getAttribute('data-label'), trigger: 'thumb' }); }
      });
    });
    if (stage) {
      var tick = false;
      stage.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var i = nearest();
          if (i === current) return;
          current = i;
          markThumb(i);
          var match = flavorForSlide(i);
          setActiveFlavor(match);
          if (match) { touched = true; broadcast(match); }
        });
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
      });
    }

    /* Rotación de sabores (Lemon -> Peach -> Watermelon) mientras la sección destino está en pantalla y nadie ha
       tocado un sobre: la tabla en L1; "Solo lo esencial" en el test (Juan: cada 2 s, amarillo -> naranja -> rojo) */
    if (sec.getAttribute('data-cycle') === '1' && flavors.length > 1 && !reduced && 'IntersectionObserver' in window) {
      var tabla = null;
      try { tabla = document.querySelector(sec.getAttribute('data-cycle-target') || '.nw-tabla'); } catch (e) {}
      var cycleMs = Math.max(1200, parseInt(sec.getAttribute('data-cycle-ms'), 10) || 2400);
      /* con el cursor encima de los sobres la rotación se para, y sigue al salir (Juan, ronda 7) */
      var hoverPaused = false, pauseSel = sec.getAttribute('data-cycle-pause');
      if (pauseSel) {
        try {
          document.querySelectorAll(pauseSel).forEach(function (el) {
            el.addEventListener('mouseenter', function () { hoverPaused = true; });
            el.addEventListener('mouseleave', function () { hoverPaused = false; });
          });
        } catch (e) {}
      }
      if (tabla) {
        var ci = 0, timer = null;
        var step = function () {
          if (touched) { clearInterval(timer); timer = null; return; }
          if (hoverPaused) return;
          broadcast(flavors[ci % flavors.length]);
          ci++;
        };
        var tio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !touched && !timer) { step(); timer = setInterval(step, cycleMs); }
            if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.35 });
        tio.observe(tabla);
      }
    }

    /* ---------- compra: 1 unidad, UTM conservados ---------- */
    var form = sec.querySelector('[data-nw-pdd-form]');
    var addBtn = sec.querySelector('[data-nw-pdd-add]');
    var errEl = sec.querySelector('[data-nw-pdd-error]');
    var busy = false;
    function showError(msg) { if (errEl) { errEl.textContent = msg || ''; errEl.hidden = !msg; } }
    function jfetch(url, body) {
      var opts = { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } };
      if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
      return fetch(root + url, opts).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) { var e = new Error('cart'); e.desc = j && (j.description || j.message); throw e; } return j; });
      });
    }
    function buy(source) {
      if (busy || !DATA.variant || (addBtn && addBtn.disabled)) return;
      busy = true;
      showError('');
      var original = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = DATA.copy.added || 'Vamos al pago…'; }
      dl('lp_add', { lp_id: lp, lp_variant: lpVar, source: source || 'ficha' });
      var vid = Number(DATA.variant);
      jfetch('cart.js')
        .then(function (cart) {
          var line = (cart.items || []).filter(function (it) { return it.variant_id === vid; })[0];
          if (!line) return jfetch('cart/add.js', { items: [{ id: vid, quantity: 1 }] });
          if (line.quantity !== 1) return jfetch('cart/change.js', { id: line.key, quantity: 1 });
          return null;
        })
        .then(function () {
          var attrs = {};
          if (lp) attrs.Landing = lp;
          if (lpVar) attrs.Variante = lpVar;
          if (!Object.keys(attrs).length) return null;
          return jfetch('cart/update.js', { attributes: attrs }).catch(function () { return null; });
        })
        .then(function () {
          var mode = DATA.afterAdd || 'checkout';
          var qs = window.location.search || '';
          window.location.href = ((mode === 'cart') ? (root + 'cart') : (root + 'checkout')) + qs;
        })
        .catch(function (err) {
          busy = false;
          if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
          showError((err && err.desc) || DATA.copy.error || 'No hemos podido añadirlo.');
        });
    }
    if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); buy('ficha'); });

    /* bfcache: al volver ATRÁS desde el checkout el JS no se re-ejecuta y busy seguía a true */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      busy = false;
      if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.add || addBtn.textContent; }
      showError('');
    });

    /* Enlaces que tienen que llevarse los UTM (agotado → landing base) */
    sec.querySelectorAll('[data-nw-keep-qs]').forEach(function (a) {
      var qs = window.location.search || '';
      if (!qs) return;
      try { var u = new URL(a.getAttribute('href'), window.location.origin); u.search = qs; a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {}
    });

    /* ---------- barra flotante: compra directa desde el 55% del viewport ---------- */
    var floatBar = sec.querySelector('[data-nw-pdd-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-pdd-floatbtn]');
    /* Rastro de la barra flotante (Kiko, 2026-10-02): mismo evento que nw-pdp-buy-box-v2.
       Aquí la barra siempre compra. */
    if (floatBtn) floatBtn.addEventListener('click', function () {
      dl('floatbar_click', { floatbar_mode: 'compra', floatbar_page: window.location.pathname });
      buy('floatbar');
    });
    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar) {
      var esLanding = document.body.classList.contains('template-landing-page');
      var shown = null, fbTick = false;
      var fbUpdate = function () {
        fbTick = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vis = esLanding ? (window.scrollY > vh * 0.55)
                            : (window.matchMedia('(max-width: 767px)').matches && addBtn && addBtn.getBoundingClientRect().bottom < 0);
        if (vis === shown) return;
        shown = vis;
        floatBar.classList.toggle('is-visible', !!vis);
        floatBar.setAttribute('aria-hidden', vis ? 'false' : 'true');
        if (floatBtn) floatBtn.tabIndex = vis ? 0 : -1;
        liftWA(vis);
      };
      var fbQueue = function () { if (!fbTick) { fbTick = true; requestAnimationFrame(fbUpdate); } };
      window.addEventListener('scroll', fbQueue, { passive: true });
      window.addEventListener('resize', fbQueue, { passive: true });
      fbUpdate();
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }

    /* ---------- medición: CTAs de toda la página que llevan a esta ficha ---------- */
    var anchorEl = sec.querySelector('.nw-pdd__anchor');
    var anchorId = anchorEl ? anchorEl.id : 'ficha';
    if (!window.__nwPddCta) {
      window.__nwPddCta = true;
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href$="#' + anchorId + '"]') : null;
        if (!a) return;
        var s = a.closest('.shopify-section');
        var loc = s && s.id ? s.id.replace(/^shopify-section-(template--\d+__)?/, '') : 'otro';
        dl('lp_cta_click', { lp_id: lp, lp_variant: lpVar, location: loc });
      }, true);
      sec.querySelectorAll('.nw-pdd__acc').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) dl('lp_acc_open', { lp_id: lp, lp_variant: lpVar, acc: (d.querySelector('.nw-pdd__acc-title') || {}).textContent || '' });
        });
      });
      dl('lp_view', { lp_id: lp, lp_variant: lpVar });
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pdd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-merch"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdpMerchInit) return;
  window.__nwPdpMerchInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { variants: [], copy: {} };
    var dataEl = sec.querySelector('[data-nw-pm-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* defaults */ } }
    DATA.variants = DATA.variants || [];
    DATA.copy = DATA.copy || {};
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.08 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var stage = sec.querySelector('[data-nw-pm-stage]');
    var slides = sec.querySelectorAll('.nw-pm__slide');
    var thumbs = sec.querySelectorAll('.nw-pm__thumb');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t) {
        var on = +t.getAttribute('data-thumb') === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function goTo(i, smooth) {
      if (!stage || !slides.length) return;
      var n = slides.length;
      i = ((i % n) + n) % n;
      var s = slides[i];
      stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: (smooth && !reduced) ? 'smooth' : 'auto' });
      setActive(i);
    }
    function nearest() {
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, idx) {
        var d = Math.abs(s.offsetLeft - stage.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < bd) { bd = d; best = idx; }
      });
      return best;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(+t.getAttribute('data-thumb'), true); });
    });
    if (stage) {
      var tick = false;
      stage.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () { tick = false; var i = nearest(); if (i !== current) setActive(i); });
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
      });
    }

    /* ---------- variantes ---------- */
    var idEl = sec.querySelector('[data-nw-pm-id]');
    var priceEl = sec.querySelector('[data-nw-pm-price]');
    var compareEl = sec.querySelector('[data-nw-pm-compare]');
    var floatPriceEl = sec.querySelector('[data-nw-pm-floatprice]');
    var addBtn = sec.querySelector('[data-nw-pm-add]');
    var opts = Array.prototype.slice.call(sec.querySelectorAll('[data-nw-pm-opt]'));

    function selected() {
      return opts.map(function (fs) {
        var r = fs.querySelector('input:checked');
        return r ? r.value : null;
      });
    }
    function findVariant(sel) {
      for (var i = 0; i < DATA.variants.length; i++) {
        var vv = DATA.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (vv.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return vv;
      }
      return null;
    }
    function paintAvailability(sel) {
      /* una píldora se tacha si, con el resto de opciones como están, no hay stock */
      opts.forEach(function (fs, oi) {
        fs.querySelectorAll('.nw-pm__pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          var trial = sel.slice(); trial[oi] = input.value;
          var match = findVariant(trial);
          pill.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function paint(vv) {
      if (!vv) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = DATA.copy.sold || 'Agotado'; }
        return;
      }
      if (idEl) idEl.value = vv.id;
      if (priceEl) priceEl.textContent = vv.price;
      if (floatPriceEl) floatPriceEl.textContent = vv.price;
      if (compareEl) {
        compareEl.textContent = vv.compare || '';
        compareEl.hidden = !vv.compare;
      }
      if (addBtn) {
        addBtn.disabled = !vv.available;
        addBtn.classList.remove('is-added');
        addBtn.textContent = vv.available ? (DATA.copy.add || 'Agregar al carrito') : (DATA.copy.sold || 'Agotado');
      }
    }
    opts.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var sel = selected();
        var vv = findVariant(sel);
        paint(vv);
        paintAvailability(sel);
        if (vv && vv.media > -1) goTo(vv.media, true);
        if (vv) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', vv.id);
            window.history.replaceState(window.history.state, '', u.toString());
          } catch (e) { /* sin URL API: la ficha sigue funcionando */ }
        }
      });
    });
    if (opts.length) paintAvailability(selected());

    /* si se llega con ?variant= a una variante con foto propia, empezar en esa foto */
    (function () {
      var vid = idEl ? String(idEl.value) : '';
      for (var i = 0; i < DATA.variants.length; i++) {
        if (String(DATA.variants[i].id) === vid && DATA.variants[i].media > 0 && /[?&]variant=/.test(window.location.search)) {
          goTo(DATA.variants[i].media, false);
        }
      }
    })();

    /* ---------- contador ---------- */
    var qtyEl = sec.querySelector('[data-nw-pm-qty]');
    function clampQty() {
      if (!qtyEl) return 1;
      var max = parseInt(qtyEl.getAttribute('max'), 10) || 10;
      var val = parseInt(qtyEl.value, 10);
      if (isNaN(val)) val = 1;
      val = Math.max(1, Math.min(max, val));
      qtyEl.value = val;
      return val;
    }
    sec.querySelectorAll('.nw-pm__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyEl) return;
        qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + (+b.getAttribute('data-step'));
        clampQty();
      });
    });
    if (qtyEl) qtyEl.addEventListener('blur', clampQty);

    /* ---------- añadir al carrito ---------- */
    var form = sec.querySelector('[data-nw-pm-form]');
    var errEl = sec.querySelector('[data-nw-pm-error]');
    var busy = false;
    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = !msg; } }

    function afterAdd(res) {
      var mode = DATA.afterAdd || 'drawer';
      if (mode === 'drawer') {
        /* el tema abre y refresca su cajón por eventBus; `sections` viene en la respuesta del add */
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.add || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart' + (window.location.search || '');
        return;
      }
      if (mode === 'stay') {
        busy = false;
        setTimeout(function () { if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.add || ''; } }, 1600);
        return;
      }
      /* propaga el query string (UTM, gclid...) y respeta el locale, igual que la PDP de LIT */
      var qs = window.location.search || '';
      window.location.href = ((mode === 'cart') ? (root + 'cart') : (root + 'checkout')) + qs;
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy) return;
        showError('');
        var vid = idEl ? idEl.value : null;
        if (!vid || (addBtn && addBtn.disabled)) return;
        busy = true;
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = DATA.copy.added || 'Añadido'; }

        var payload = { items: [{ id: Number(vid), quantity: clampQty() }] };
        if ((DATA.afterAdd || 'drawer') === 'drawer') payload.sections = 'cart-drawer';

        fetch(root + 'cart/add.js', {
          method: 'POST', body: JSON.stringify(payload),
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            showError((err && err.desc) || DATA.copy.error || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- barra flotante móvil (misma lógica que la PDP de LIT) ---------- */
    var floatBar = sec.querySelector('[data-nw-pm-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-pm-floatbtn]');
    if (floatBtn && form) {
      floatBtn.addEventListener('click', function () {
        form.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    }
    /* la burbuja de WhatsApp vive en un shadow root: se sube para que no tape la barra */
    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && addBtn) {
      /* Visible solo cuando el botón de compra real ya ha quedado por ENCIMA de la pantalla.
         Se calcula en cada scroll (no con IntersectionObserver): un salto de golpe arriba
         (scrollTo, ancla) no cruza el botón, el observer no se entera y la barra se quedaba
         puesta encima del título. */
      var mq = window.matchMedia('(max-width: 767px)');
      var fbShown = null, fbTick = false;
      var fbUpdate = function () {
        fbTick = false;
        var vis = mq.matches && addBtn.getBoundingClientRect().bottom < 0;
        if (vis === fbShown) return;
        fbShown = vis;
        floatBar.classList.toggle('is-visible', vis);
        floatBar.setAttribute('aria-hidden', vis ? 'false' : 'true');
        if (floatBtn) floatBtn.tabIndex = vis ? 0 : -1;
        liftWA(vis);
      };
      var fbQueue = function () { if (!fbTick) { fbTick = true; requestAnimationFrame(fbUpdate); } };
      window.addEventListener('scroll', fbQueue, { passive: true });
      window.addEventListener('resize', fbQueue, { passive: true });
      fbUpdate();
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-simple-bak-20261002"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdpSimpleInit) return;
  window.__nwPdpSimpleInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { variants: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdps-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.variants = DATA.variants || {};
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: .08 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var stage = sec.querySelector('.nw-pdp__stage');
    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');

    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = slides.length; if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        if (galSwipeable()) {
          var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        }
        galSetActive(i);
      });
    });
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () { galTick = false; galSetActive(galCurrent()); });
      }, { passive: true });
    }
    var many = slides.length > 1;
    if (navPrev) { navPrev.hidden = !many; navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); }); }
    if (navNext) { navNext.hidden = !many; navNext.addEventListener('click', function () { galGo(galCurrent() + 1); }); }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = galRoot && galRoot.getAttribute('data-nw-autoplay') === 'true';
    if (autoplayOn && stage && many) {
      var autoPaused = false, resumeT = null;
      function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
      setInterval(function () { if (!autoPaused) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; });
      }
    }

    /* ---------- stepper ---------- */
    var qtyEl = sec.querySelector('[data-nw-qty]');
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyEl) return;
        var max = parseInt(qtyEl.getAttribute('max'), 10) || 10;
        var min = parseInt(qtyEl.getAttribute('min'), 10) || 1;
        var val = parseInt(qtyEl.value, 10) || min;
        val += (+b.getAttribute('data-step'));
        qtyEl.value = Math.max(min, Math.min(max, val));
      });
    });

    /* ---------- variante ---------- */
    var idEl = sec.querySelector('[data-nw-id]');
    var priceEl = sec.querySelector('[data-nw-price]');
    var compareEl = sec.querySelector('[data-nw-compare]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var selectEl = sec.querySelector('[data-nw-variant-select]');

    function paint(vid) {
      var info = DATA.variants[String(vid)];
      if (!info) return;
      if (idEl) idEl.value = vid;
      if (priceEl) priceEl.textContent = info.price;
      if (floatPriceEl) floatPriceEl.textContent = info.price;
      if (compareEl) {
        if (info.compare) { compareEl.textContent = info.compare; compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !info.available;
        addBtn.textContent = info.available ? (DATA.copy.addLabel || 'Agregar al carrito') : (DATA.copy.unavailable || 'No disponible');
      }
    }
    if (selectEl) {
      selectEl.addEventListener('change', function () {
        paint(selectEl.value);
        /* el ?variant= de la URL, para que compartir el enlace conserve la elección */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', selectEl.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* URL no soportada: la ficha sigue funcionando */ }
      });
    }

    /* ---------- añadir al carrito ---------- */
    var form = sec.querySelector('[data-nw-pdps-form]');
    var errEl = sec.querySelector('[data-nw-error]');
    var busy = false;

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart';
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      window.location.href = (mode === 'cart') ? (root + 'cart') : '/checkout';
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy) return;
        clearError();
        var vid = idEl ? idEl.value : null;
        if (!vid) { showError(DATA.copy.addError || 'No hemos podido añadirlo.'); return; }
        busy = true;

        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }

        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var payload = { items: [{ id: Number(vid), quantity: qty }] };
        if (DATA.afterAdd === 'drawer') payload.sections = 'cart-drawer';
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

        fetch(root + 'cart/add.js', { method: 'POST', body: JSON.stringify(payload), headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
      });
    }
    if (floatBar && form && 'IntersectionObserver' in window) {
      /* se enseña cuando el bloque de compra sale de pantalla, no antes */
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { floatBar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 });
      fio.observe(form);
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pdp-simple]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-simple-bak-20261002b"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdpSimpleInit) return;
  window.__nwPdpSimpleInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { variants: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdps-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.variants = DATA.variants || {};
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: .08 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var stage = sec.querySelector('.nw-pdp__stage');
    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');

    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = slides.length; if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        if (galSwipeable()) {
          var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        }
        galSetActive(i);
      });
    });
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () { galTick = false; galSetActive(galCurrent()); });
      }, { passive: true });
    }
    var many = slides.length > 1;
    if (navPrev) { navPrev.hidden = !many; navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); }); }
    if (navNext) { navNext.hidden = !many; navNext.addEventListener('click', function () { galGo(galCurrent() + 1); }); }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = galRoot && galRoot.getAttribute('data-nw-autoplay') === 'true';
    if (autoplayOn && stage && many) {
      var autoPaused = false, resumeT = null;
      function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
      setInterval(function () { if (!autoPaused) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; });
      }
    }

    /* ---------- stepper ---------- */
    var qtyEl = sec.querySelector('[data-nw-qty]');
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyEl) return;
        var max = parseInt(qtyEl.getAttribute('max'), 10) || 10;
        var min = parseInt(qtyEl.getAttribute('min'), 10) || 1;
        var val = parseInt(qtyEl.value, 10) || min;
        val += (+b.getAttribute('data-step'));
        qtyEl.value = Math.max(min, Math.min(max, val));
      });
    });

    /* ---------- variante ---------- */
    var idEl = sec.querySelector('[data-nw-id]');
    var priceEl = sec.querySelector('[data-nw-price]');
    var compareEl = sec.querySelector('[data-nw-compare]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var selectEl = sec.querySelector('[data-nw-variant-select]');

    function paint(vid) {
      var info = DATA.variants[String(vid)];
      if (!info) return;
      if (idEl) idEl.value = vid;
      if (priceEl) priceEl.textContent = info.price;
      if (floatPriceEl) floatPriceEl.textContent = info.price;
      if (compareEl) {
        if (info.compare) { compareEl.textContent = info.compare; compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !info.available;
        addBtn.textContent = info.available ? (DATA.copy.addLabel || 'Agregar al carrito') : (DATA.copy.unavailable || 'No disponible');
      }
    }
    if (selectEl) {
      selectEl.addEventListener('change', function () {
        paint(selectEl.value);
        /* el ?variant= de la URL, para que compartir el enlace conserve la elección */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', selectEl.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* URL no soportada: la ficha sigue funcionando */ }
      });
    }

    /* ---------- añadir al carrito ---------- */
    var form = sec.querySelector('[data-nw-pdps-form]');
    var errEl = sec.querySelector('[data-nw-error]');
    var busy = false;

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart';
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      window.location.href = (mode === 'cart') ? (root + 'cart') : '/checkout';
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy) return;
        clearError();
        var vid = idEl ? idEl.value : null;
        if (!vid) { showError(DATA.copy.addError || 'No hemos podido añadirlo.'); return; }
        busy = true;

        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }

        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var payload = { items: [{ id: Number(vid), quantity: qty }] };
        if (DATA.afterAdd === 'drawer') payload.sections = 'cart-drawer';
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

        fetch(root + 'cart/add.js', { method: 'POST', body: JSON.stringify(payload), headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA (Juan, 2026-10-02): todas las PDPs y landings con el mismo botón
           flotante, "Agregar al carrito" + precio, que añade y va al checkout. Se dispara el
           MISMO submit del formulario, así hereda validación, cantidad, errores y `after_add`.
           Si el botón real está desactivado (agotado), se lleva a la ficha, donde se ve. */
        if (form && !(addBtn && addBtn.disabled)) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          return;
        }
        var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* Volver ATRÁS desde el checkout restaura la página desde bfcache con `busy` aún en true
       y el botón muerto hasta refrescar (mismo arreglo que nw-pdp-buy-box-v2, 2026-09-23). */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      busy = false;
      if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
      clearError();
    });
    /* El botón de WhatsApp (Permut, shadow DOM) sube 72px mientras la barra está visible para
       no taparle el precio. Copiado tal cual de nw-pdp-buy-box-v2. */
    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && form && 'IntersectionObserver' in window) {
      /* se enseña cuando el bloque de compra sale de pantalla, no antes */
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          floatBar.classList.toggle('is-visible', !e.isIntersecting);
          liftWA(!e.isIntersecting);
        });
      }, { threshold: 0 });
      fio.observe(form);
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pdp-simple]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-simple"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPdpSimpleInit) return;
  window.__nwPdpSimpleInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var DATA = { variants: {}, copy: {} };
    var dataEl = sec.querySelector('[data-nw-pdps-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* deja los defaults */ } }
    DATA.variants = DATA.variants || {};
    DATA.copy = DATA.copy || {};

    /* ---------- reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: .08 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* ---------- galería ---------- */
    var stage = sec.querySelector('.nw-pdp__stage');
    var slides = sec.querySelectorAll('.nw-pdp__slide');
    var thumbs = sec.querySelectorAll('.nw-pdp__thumb');
    var navPrev = sec.querySelector('.nw-pdp__nav--prev');
    var navNext = sec.querySelector('.nw-pdp__nav--next');

    function galSetActive(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-slide') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-thumb') === i); });
    }
    function galSwipeable() { return stage && stage.scrollWidth > stage.clientWidth + 5; }
    function galCurrent() {
      if (!stage) return 0;
      var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = +s.getAttribute('data-slide'); }
      });
      return best;
    }
    function galGo(i) {
      var n = slides.length; if (!stage || n < 1) return;
      i = ((i % n) + n) % n;
      var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      galSetActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        if (galSwipeable()) {
          var slide = sec.querySelector('.nw-pdp__slide[data-slide="' + i + '"]');
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        }
        galSetActive(i);
      });
    });
    if (stage) {
      var galTick = false;
      stage.addEventListener('scroll', function () {
        if (!galSwipeable() || galTick) return;
        galTick = true;
        requestAnimationFrame(function () { galTick = false; galSetActive(galCurrent()); });
      }, { passive: true });
    }
    var many = slides.length > 1;
    if (navPrev) { navPrev.hidden = !many; navPrev.addEventListener('click', function () { galGo(galCurrent() - 1); }); }
    if (navNext) { navNext.hidden = !many; navNext.addEventListener('click', function () { galGo(galCurrent() + 1); }); }

    var galRoot = sec.querySelector('[data-nw-gallery]');
    var autoplayOn = galRoot && galRoot.getAttribute('data-nw-autoplay') === 'true';
    if (autoplayOn && stage && many) {
      var autoPaused = false, resumeT = null;
      function pauseTemp() { autoPaused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { autoPaused = false; }, 8000); }
      setInterval(function () { if (!autoPaused) galGo(galCurrent() + 1); }, 4500);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, pauseTemp, { passive: true }); });
      var wrapEl = sec.querySelector('.nw-pdp__stage-wrap');
      if (wrapEl) {
        wrapEl.addEventListener('mouseenter', function () { autoPaused = true; });
        wrapEl.addEventListener('mouseleave', function () { autoPaused = false; });
      }
    }

    /* ---------- stepper ---------- */
    var qtyEl = sec.querySelector('[data-nw-qty]');
    sec.querySelectorAll('.nw-pdp__step').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyEl) return;
        var max = parseInt(qtyEl.getAttribute('max'), 10) || 10;
        var min = parseInt(qtyEl.getAttribute('min'), 10) || 1;
        var val = parseInt(qtyEl.value, 10) || min;
        val += (+b.getAttribute('data-step'));
        qtyEl.value = Math.max(min, Math.min(max, val));
      });
    });

    /* ---------- variante ---------- */
    var idEl = sec.querySelector('[data-nw-id]');
    var priceEl = sec.querySelector('[data-nw-price]');
    var compareEl = sec.querySelector('[data-nw-compare]');
    var floatPriceEl = sec.querySelector('[data-nw-floatprice]');
    var addBtn = sec.querySelector('[data-nw-add]');
    var selectEl = sec.querySelector('[data-nw-variant-select]');

    function paint(vid) {
      var info = DATA.variants[String(vid)];
      if (!info) return;
      if (idEl) idEl.value = vid;
      if (priceEl) priceEl.textContent = info.price;
      if (floatPriceEl) floatPriceEl.textContent = info.price;
      if (compareEl) {
        if (info.compare) { compareEl.textContent = info.compare; compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !info.available;
        addBtn.textContent = info.available ? (DATA.copy.addLabel || 'Agregar al carrito') : (DATA.copy.unavailable || 'No disponible');
      }
    }
    if (selectEl) {
      selectEl.addEventListener('change', function () {
        paint(selectEl.value);
        /* el ?variant= de la URL, para que compartir el enlace conserve la elección */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', selectEl.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* URL no soportada: la ficha sigue funcionando */ }
      });
    }

    /* ---------- añadir al carrito ---------- */
    var form = sec.querySelector('[data-nw-pdps-form]');
    var errEl = sec.querySelector('[data-nw-error]');
    var busy = false;

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

    function afterAdd(res) {
      var mode = DATA.afterAdd || 'checkout';
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      if (mode === 'drawer') {
        busy = false;
        if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
        if (window.eventBus) {
          if (res) window.eventBus.emit('update:cart:drawer', res);
          window.eventBus.emit('open:cart:drawer');
        }
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        if (!window.eventBus) window.location.href = root + 'cart';
        return;
      }
      if (mode === 'stay') { busy = false; return; }
      window.location.href = (mode === 'cart') ? (root + 'cart') : '/checkout';
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy) return;
        clearError();
        var vid = idEl ? idEl.value : null;
        if (!vid) { showError(DATA.copy.addError || 'No hemos podido añadirlo.'); return; }
        busy = true;

        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.classList.add('is-added'); addBtn.textContent = (addBtn.getAttribute('data-added') || 'Añadido'); }

        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
        var payload = { items: [{ id: Number(vid), quantity: qty }] };
        if (DATA.afterAdd === 'drawer') payload.sections = 'cart-drawer';
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

        fetch(root + 'cart/add.js', { method: 'POST', body: JSON.stringify(payload), headers: headers })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok || (res.body && res.body.status)) {
              var err = new Error('cart');
              err.desc = res.body && (res.body.description || res.body.message);
              throw err;
            }
            afterAdd(res.body);
          })
          .catch(function (err) {
            busy = false;
            if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = original; }
            showError((err && err.desc) || DATA.copy.addError || 'No hemos podido añadirlo.');
          });
      });
    }

    /* ---------- barra flotante móvil ---------- */
    var floatBar = sec.querySelector('[data-nw-floatbar]');
    var floatBtn = sec.querySelector('[data-nw-floatadd]');
    if (floatBtn) {
      floatBtn.addEventListener('click', function () {
        /* COMPRA DIRECTA (Juan, 2026-10-02): todas las PDPs y landings con el mismo botón
           flotante, "Agregar al carrito" + precio, que añade y va al checkout. Se dispara el
           MISMO submit del formulario, así hereda validación, cantidad, errores y `after_add`.
           Si el botón real está desactivado (agotado), se lleva a la ficha, donde se ve. */
        var fbMode = (form && !(addBtn && addBtn.disabled)) ? 'compra' : 'scroll';
        /* Rastro de la barra flotante (Kiko, 2026-10-02): GTM lo manda a GA4 como `floatbar_click`
           con floatbar_mode (compra | scroll) y floatbar_page, para saber qué parte del carrito
           viene de la barra. */
        try {
          (window.dataLayer = window.dataLayer || []).push({ event: 'floatbar_click', floatbar_mode: fbMode, floatbar_page: window.location.pathname });
        } catch (e) { /* sin dataLayer la barra sigue funcionando */ }
        if (fbMode === 'compra') {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          return;
        }
        var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* Volver ATRÁS desde el checkout restaura la página desde bfcache con `busy` aún en true
       y el botón muerto hasta refrescar (mismo arreglo que nw-pdp-buy-box-v2, 2026-09-23). */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      busy = false;
      if (addBtn) { addBtn.classList.remove('is-added'); addBtn.textContent = DATA.copy.addLabel || addBtn.textContent; }
      clearError();
    });
    /* El botón de WhatsApp (Permut, shadow DOM) sube 72px mientras la barra está visible para
       no taparle el precio. Copiado tal cual de nw-pdp-buy-box-v2. */
    var waStyleDone = false;
    function ensureWaStyle() {
      if (waStyleDone) return;
      var host = document.querySelector('[data-permut-main]');
      if (!host || !host.shadowRoot) return;
      var st = document.createElement('style');
      st.textContent = '.whatsapp-button,.omni-button{transition:transform .35s cubic-bezier(.16,1,.3,1)!important}' +
        ':host(.nw-wa-up) .whatsapp-button,:host(.nw-wa-up) .omni-button{transform:translateY(-72px)!important}';
      host.shadowRoot.appendChild(st);
      waStyleDone = true;
    }
    function liftWA(on) {
      var host = document.querySelector('[data-permut-main]');
      if (!host) return;
      ensureWaStyle();
      host.classList.toggle('nw-wa-up', !!on);
    }
    if (floatBar && form && 'IntersectionObserver' in window) {
      /* se enseña cuando el bloque de compra sale de pantalla, no antes */
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          floatBar.classList.toggle('is-visible', !e.isIntersecting);
          liftWA(!e.isIntersecting);
        });
      }, { threshold: 0 });
      fio.observe(form);
      setTimeout(ensureWaStyle, 1500);
      setTimeout(ensureWaStyle, 4000);
    }
  }

  function boot() { document.querySelectorAll('[data-nw-pdp-simple]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-prensa"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPrensaInit) return;
  window.__nwPrensaInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    // Marquee de logos — translateX con requestAnimationFrame (idéntico a PDP live)
    var track = sec.querySelector('.nw-prensa__logos-track');
    var inner = sec.querySelector('.nw-prensa__logos-inner');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (track && inner && !reduce) {
      var speed = window.innerWidth <= 749 ? 0.85 : 0.6;
      var pos = 0;
      var paused = false;
      function tick() {
        if (!paused) {
          pos -= speed;
          if (Math.abs(pos) >= inner.scrollWidth / 2) pos = 0;
          inner.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(tick);
      }
      if (window.matchMedia('(hover: hover)').matches) {
        track.addEventListener('mouseenter', function () { paused = true; });
        track.addEventListener('mouseleave', function () { paused = false; });
      }
      window.addEventListener('resize', function () {
        speed = window.innerWidth <= 749 ? 0.85 : 0.6;
      });
      tick();
    }
  }
  function boot() { document.querySelectorAll('.nw-prensa[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-principios"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwPrincipiosInit) return;
  window.__nwPrincipiosInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.12 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-principios[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-problema"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwProblemaInit) return;
  window.__nwProblemaInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* parallax de fondo */
    var img = sec.querySelector('.nw-problema__img');
    if (img && !reduced) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var r = sec.getBoundingClientRect(), vh = window.innerHeight;
          if (r.bottom > 0 && r.top < vh) {
            var p = (r.top + r.height / 2 - vh / 2) / vh;
            img.style.transform = 'translateY(' + (p * -4) + '%)';
          }
          ticking = false;
        });
      }, { passive: true });
    }

    /* dots mobile */
    var wrap = sec.querySelector('[data-nw-bubbles]');
    var dotsWrap = sec.querySelector('[data-nw-dots]');
    var bubbles = sec.querySelectorAll('.nw-problema__bubble');
    if (wrap && dotsWrap && bubbles.length) {
      bubbles.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'nw-problema__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
      });
      var dots = dotsWrap.querySelectorAll('.nw-problema__dot');
      wrap.addEventListener('scroll', function () {
        var idx = Math.round(wrap.scrollLeft / (wrap.scrollWidth / bubbles.length));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }
  }
  function boot() { document.querySelectorAll('.nw-problema[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwReviewsInit) return;
  window.__nwReviewsInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }

    /* drag para arrastrar el carrusel con ratón */
    var vp = sec.querySelector('[data-nw-reviews-vp]');
    if (!vp) return;
    var down = false, startX = 0, startScroll = 0, moved = false;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startScroll = vp.scrollLeft;
      vp.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      vp.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; vp.classList.remove('is-dragging');
    });
    vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
  }
  function boot() { document.querySelectorAll('.nw-reviews[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-rutina"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwRutinaInit) return;
  window.__nwRutinaInit = true;
  function flipTime(el, finalStr, reduced) {
    if (reduced) { el.textContent = finalStr; return; }
    var parts = finalStr.split(':');
    var target = parseInt(parts[0], 10) || 0;
    var mm = parts[1] || '00';
    var start = null, dur = 900;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      var hh = Math.round(target * e);
      el.textContent = ('0' + hh).slice(-2) + ':' + mm;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = finalStr;
    }
    requestAnimationFrame(step);
  }
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var times = sec.querySelectorAll('[data-nw-time]');
    function run() {
      sec.classList.add('is-in');
      times.forEach(function (t, i) { setTimeout(function () { flipTime(t, t.getAttribute('data-final'), reduced); }, 200 + i * 160); });
    }
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { run(); }
  }
  function boot() { document.querySelectorAll('.nw-rutina[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-sabores"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwSaboresInit) return;
  window.__nwSaboresInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var anchor = sec.getAttribute('data-nw-anchor') || 'ficha';
    var packs = [].slice.call(sec.querySelectorAll('[data-nw-pack]'));

    /* ---------- entrada ----------
       Es lo único que queda de JS ligado a la presentación. Con la fila fija ya no hay
       que medir el alto del stage (--fanh), ni atar el módulo del abanico a la fila
       (--mrow), ni conducir el foco por scroll en móvil: todo eso se ha eliminado. */
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else {
      sec.classList.add('is-in');
    }

    /* ---------- parallax suave del fondo (igual que nw-problema) ---------- */
    var img = sec.querySelector('.nw-sabores__img');
    if (img && !reduced) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var r = sec.getBoundingClientRect(), vh = window.innerHeight;
          if (r.bottom > 0 && r.top < vh) {
            var p = (r.top + r.height / 2 - vh / 2) / vh;
            img.style.transform = 'translateY(' + (p * -4) + '%)';
          }
          ticking = false;
        });
      }, { passive: true });
    }

    /* ---------- scroll al ancla ---------- */
    function scrollToFicha() {
      var t = document.getElementById(anchor);
      if (!t) return false;
      /* El header fijo de las landings es .nw-lhead; scroll-margin-top ya lo cubre. */
      try { t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }
      catch (err) { t.scrollIntoView(true); }
      return true;
    }

    /* ---------- preselección de sabor en la ficha ----------
       SIN CAMBIOS: la ficha nw-pdp-buy-box-v2 NO se toca, aquí solo se LEE su DOM, y se
       lee el estado ANTES de hacer click. Con el pack activo (data-nw-boxes="4") el click
       ASIGNA el sabor a un hueco del pack y con data-nw-flavor-mode="navigate" navega
       fuera de la landing: en ambos casos, y si el sabor está agotado, solo se hace
       scroll. */
    function preselect(handle) {
      if (!handle) return false;
      var pdp = document.querySelector('[data-nw-pdp2]');
      if (!pdp) return false;
      if (pdp.getAttribute('data-nw-flavor-mode') === 'navigate') return false;
      if (pdp.getAttribute('data-nw-boxes') === '4') return false;
      var card = pdp.querySelector('[data-nw-flavor-card][data-flavor="' + handle.replace(/"/g, '\\"') + '"]');
      if (!card) return false;
      if (card.getAttribute('data-available') !== '1') return false;
      card.click();
      return true;
    }

    /* Si no hay ficha en la página se deja pasar el enlace (por eso el href siempre tiene
       valor: nunca href="" recargando la página). */
    packs.forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (!document.getElementById(anchor)) return;
        e.preventDefault();
        preselect(p.getAttribute('data-flavor'));
        scrollToFicha();
      });
    });

    var cta = sec.querySelector('[data-nw-sabores-cta]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        if (!document.getElementById(anchor)) return;
        e.preventDefault();
        scrollToFicha();
      });
    }
  }

  function boot() { document.querySelectorAll('.nw-sabores[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-sodio"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwSodioInit) return;
  window.__nwSodioInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.16 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
    // Sin parallax: fondo estático (mejor rendimiento y encuadre menos ampliado).
  }
  function boot() { document.querySelectorAll('[data-nw-sodio]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-solo-esencial"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwEsencialInit) return;
  window.__nwEsencialInit = true;
  function baseTransform(l) {
    return l.className.indexOf('--duo') !== -1 ? 'translate(-50%, -50%) ' : '';
  }
  /* Cambio de sabor: la ficha (nw-pdp-buy-box-v2) emite `nw:flavor` con el handle.
     Cada sección se suscribe una vez y cambia su imagen con un fundido corto. La imagen
     nueva se precarga antes de pintarla para que no haya un frame en blanco. */
  function wireFlavor(sec) {
    var img = sec.querySelector('[data-nw-esencial-img]');
    var tag = sec.querySelector('[data-nw-esencial-flavors]');
    if (!img || !tag) return;
    var map;
    try { map = JSON.parse(tag.textContent || '{}'); } catch (e) { return; }
    if (!map || !Object.keys(map).length) return;
    var media = img.parentNode;
    document.addEventListener('nw:flavor', function (e) {
      var h = e && e.detail && e.detail.handle;
      var f = h && map[h];
      if (!f || !f.src || img.getAttribute('src') === f.src) return;
      var pre = new Image();
      pre.onload = function () {
        media.classList.add('is-swapping');
        setTimeout(function () {
          img.src = f.src;
          if (f.alt) img.alt = f.alt;
          media.classList.remove('is-swapping');
        }, 180);
      };
      pre.onerror = function () { img.src = f.src; };   /* sin precarga, pero cambia igual */
      pre.src = f.src;
    });
  }
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    wireFlavor(sec);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
    if (reduced) return;
    var layers = sec.querySelectorAll('[data-nw-layer]');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom > 0 && r.top < vh) {
          var pr = (r.top + r.height / 2 - vh / 2) / vh;
          layers.forEach(function (l) {
            var k = parseFloat(l.getAttribute('data-nw-layer')) || 0.1;
            l.style.transform = baseTransform(l) + 'translateY(' + (pr * k * 90) + 'px)';
          });
        }
        ticking = false;
      });
    }, { passive: true });
  }
  function boot() { document.querySelectorAll('.nw-esencial[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-stores"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwStoresInit) return;
  window.__nwStoresInit = true;

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = sec.querySelectorAll('[data-reveal]');

    if (!('IntersectionObserver' in window) || reduced) {
      sec.classList.add('is-in');
      items.forEach(function (el) { if (el.parentNode) el.parentNode.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    var groups = sec.querySelectorAll('.nw-stores__head-inner, .nw-stores__map, .nw-stores__band-head, .nw-stores__grid, .nw-stores__closer');
    if (groups.length) {
      groups.forEach(function (g) { io.observe(g); });
      /* seguridad: revela todo pasado 1.4s por si algún grupo no cruza el umbral */
      setTimeout(function () { sec.classList.add('is-in'); }, 1400);
    } else {
      sec.classList.add('is-in');
    }
  }

  function boot() { document.querySelectorAll('[data-nw-stores]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-tabla-comparativa"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwTablaInit) return;
  window.__nwTablaInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    wireFlavor(sec);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.15 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  /* Cambio de sabor: la ficha (nw-pdp-buy-box-v2) emite `nw:flavor`. Aquí solo se cambian
     dos custom properties del sobre — el dibujo y las botellas no se tocan. */
  function wireFlavor(sec) {
    var ico = sec.querySelector('[data-nw-tabla-sachet]');
    var tag = sec.querySelector('[data-nw-tabla-flavors]');
    if (!ico || !tag) return;
    var map;
    try { map = JSON.parse(tag.textContent || '{}'); } catch (e) { return; }
    if (!map || !Object.keys(map).length) return;
    document.addEventListener('nw:flavor', function (e) {
      var h = e && e.detail && e.detail.handle;
      var f = h && map[h];
      if (!f) return;
      ico.style.setProperty('--nw-sachet', f.c);
      ico.style.setProperty('--nw-sachet-dark', f.d);
    });
  }

  function boot() { document.querySelectorAll('.nw-tabla[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-test-hidratacion"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwHtInit) return;
  window.__nwHtInit = true;

  // Meta, sin clics automáticos en esta página: el píxel de la app de Facebook manda el texto de cada botón pulsado
  // (SubscribedButtonClick), y aquí los botones son las respuestas, síntomas incluidos. El interruptor "Eventos
  // automáticos" de Events Manager ya está en No y no lo corta (30/09). Lead, QuizStart y PageView siguen saliendo.
  (function noAutoClicks(n) {
    if (typeof window.fbq === 'function') { try { window.fbq('set', 'autoConfig', false, '3064028457095340'); } catch (e) {} return; }
    if (n < 600) setTimeout(function () { noAutoClicks(n + 1); }, 100);
  })(0);

  var DOMAINS = ['gmail.com', 'hotmail.com', 'hotmail.es', 'outlook.com', 'outlook.es', 'yahoo.es', 'yahoo.com', 'icloud.com', 'live.com', 'telefonica.net'];
  var SACHET_COLORS = [['#E0DF69', '#C4C14D'], ['#E05850', '#C0463F'], ['#EF9B55', '#CC8145']];
  var CHECK = '<svg class="nw-ht-opt__check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="2" stroke="currentColor" stroke-width="1.2"/><path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke="currentColor" stroke-width="1.2"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ss(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function uuid() { try { return crypto.randomUUID(); } catch (e) { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); } }
  function privacy() { return (window.Shopify && window.Shopify.customerPrivacy) || null; }
  function analyticsOk() { var p = privacy(); try { return !p || typeof p.analyticsProcessingAllowed !== 'function' || p.analyticsProcessingAllowed(); } catch (e) { return false; } }
  function marketingOk() { var p = privacy(); try { return !!(p && typeof p.marketingAllowed === 'function' && p.marketingAllowed()); } catch (e) { return false; } }
  function track(ev, params) { if (!analyticsOk()) return; try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev, quiz_id: 'ht_v1' }, params || {})); } catch (e) {} }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function lev(a, b) {
    var m = [], i, j;
    for (i = 0; i <= b.length; i++) m[i] = [i];
    for (j = 0; j <= a.length; j++) m[0][j] = j;
    for (i = 1; i <= b.length; i++) for (j = 1; j <= a.length; j++) m[i][j] = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + (b[i - 1] === a[j - 1] ? 0 : 1));
    return m[b.length][a.length];
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var C; try { C = JSON.parse(sec.querySelector('[data-nw-ht-config]').textContent); } catch (e) { return; }
    var Q = C.questions || []; if (!Q.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var screen = sec.querySelector('[data-nw-ht-screen]');
    var segsEl = sec.querySelector('[data-nw-ht-segs]');
    var cursor = sec.querySelector('[data-nw-ht-cursor]');
    var countEl = sec.querySelector('[data-nw-ht-count]');
    var backBtn = sec.querySelector('[data-nw-ht-back]');
    var capTpl = sec.querySelector('[data-nw-ht-capture-tpl]');
    var calcTpl = sec.querySelector('[data-nw-ht-calc-tpl]');
    var S = ss('lit_ht_draft');
    if (!S || !S.answers) S = { uid: 'ht-' + uuid(), answers: {}, idx: 0, started: 0 };
    var advancing = false, painted = false, viewed = false;

    function save() { ss('lit_ht_draft', S); }
    function visibleQs() {
      return Q.filter(function (q) {
        if (!q.showIf) return true;
        var m = String(q.showIf).match(/^(\w+)\s*(!=|=)\s*(.+)$/); if (!m) return true;
        var val = S.answers[m[1]], target = m[3].trim();
        if (val === undefined) return m[2] === '!=';
        var has = Array.isArray(val) ? val.indexOf(target) > -1 : String(val) === target;
        return m[2] === '=' ? has : !has;
      });
    }
    function progress(i, total) {
      var spans = segsEl.children;
      /* el número de tramos sigue al de preguntas visibles (la del sudor solo si entrenas) */
      while (spans.length > total) segsEl.removeChild(spans[spans.length - 1]);
      while (spans.length < total) segsEl.appendChild(document.createElement('span'));
      for (var k = 0; k < spans.length; k++) spans[k].className = k < i ? 'is-done' : '';
      var pct = total ? Math.min(100, (i / total) * 100) : 100;
      cursor.style.left = 'calc((100% - 30px) * ' + (pct / 100) + ')';
      var third = Math.min(2, Math.floor((i / Math.max(1, total)) * 3));
      cursor.style.setProperty('--c', SACHET_COLORS[third][0]); cursor.style.setProperty('--cd', SACHET_COLORS[third][1]);
      countEl.textContent = i < total ? (C.copy.count || '{n} de {t}').replace('{n}', i + 1).replace('{t}', total) : '';
      backBtn.hidden = i === 0;
    }
    function enter() { screen.classList.remove('is-enter'); void screen.offsetWidth; screen.classList.add('is-enter'); }
    function keepInView() {
      /* cada paso cambia en su sitio: si el test se ha ido de pantalla, se vuelve a él */
      var r = sec.getBoundingClientRect();
      if (r.top < -40 || r.top > 40) window.scrollTo({ top: window.scrollY + r.top, behavior: reduced ? 'auto' : 'smooth' });
    }
    /* una sola frase bajo las respuestas: privacidad (solo si la respuesta se queda en el dispositivo) + "orientativo" */
    function fine(q) {
      /* una sola frase (Juan): en las preguntas locales, la versión unida si existe */
      var t = (q.local && C.copy.localFine) ? C.copy.localFine : ((q.local ? (C.copy.local || '') + ' ' : '') + (C.copy.fine || '')).trim();
      return t ? '<p class="nw-ht-scr__fine">' + (q.local ? LOCK : '') + '<span>' + esc(t) + '</span></p>' : '';
    }
    function paint(i, opts) {
      opts = opts || {};
      sec.classList.remove('is-wide');
      var list = visibleQs();
      if (i >= list.length) return paintCapture();
      S.idx = i; save();
      /* la primera pregunta nunca sale premarcada (Juan, ronda 4), ni al volver atrás */
      var q = list[i], multi = q.type === 'multi', cur = i === 0 ? undefined : S.answers[q.key];
      progress(i, list.length);
      sec.classList.toggle('is-going', i > 0);
      var parts = String(q.text || '').split('|');
      var html = '<div class="nw-ht-scr"><div class="nw-ht-scr__qcol">' + (opts.resume ? '<p class="nw-ht__resume">' + esc(C.copy.resume) + '</p>' : '') +
        '<p class="nw-ht-scr__q" role="heading" aria-level="2"><span class="l1">' + esc(parts[0].trim()) + '</span>' + (parts[1] ? '<span class="l2">' + esc(parts[1].trim()) + '</span>' : '') + '</p>' +
        (q.help ? '<p class="nw-ht-scr__help">' + esc(q.help) + '</p>' : '') + '</div><div class="nw-ht-scr__ocol">' +
        '<div class="nw-ht-scr__opts' + (multi && q.options.length >= 4 ? ' is-grid' : '') + '" role="' + (multi ? 'group' : 'radiogroup') + '" aria-label="' + esc(String(q.text).replace('|', ' ')) + '">';
      var L = 'ABCDEFGH';
      q.options.forEach(function (o, k) {
        var on = multi ? (Array.isArray(cur) && cur.indexOf(o.v) > -1) : cur === o.v;
        var btn = '<button type="button" class="nw-ht-opt' + (multi ? ' is-multi' : '') + (on ? ' is-on' : '') + '" role="' + (multi ? 'checkbox' : 'radio') + '" aria-checked="' + (on ? 'true' : 'false') + '" data-v="' + esc(o.v) + '">' +
          '<span class="nw-ht-opt__idx" aria-hidden="true">' + L[k] + '</span><span>' + esc(o.l) + '</span>' + CHECK + '</button>';
        /* "Otro": se escribe dentro de su propia casilla, así la pregunta no crece (Juan, 01/10). El texto no sale del navegador */
        if (multi && q.other && o.v === q.other) {
          var ph = q.otherPh || '¿Qué notas?';
          btn = '<div class="nw-ht-optwrap' + (on ? ' is-on' : '') + '">' + btn + '<input type="text" class="nw-ht-other" data-nw-ht-other maxlength="60" autocomplete="off" enterkeyhint="next" placeholder="' + esc(ph) + '" aria-label="' + esc(o.l + ': ' + ph) + '" value="' + esc(S.answers[q.key + '_txt'] || '') + '"' + (on ? '' : ' hidden') + '></div>';
        }
        html += btn;
      });
      html += '</div>' + (multi ? '<button type="button" class="nw-ht-next" data-nw-ht-next' + ((Array.isArray(cur) && cur.length) ? '' : ' disabled') + '>' + esc(C.copy.next || 'Siguiente') + '</button>' : '') +
        (multi ? '' : '<p class="nw-ht-scr__react" data-react aria-live="polite"></p>') + fine(q) + '</div></div>';
      screen.innerHTML = html;
      /* respuestas locales: fuera de las grabaciones de Hotjar y Contentsquare */
      if (q.local) { screen.setAttribute('data-hj-suppress', ''); screen.setAttribute('data-cs-mask', ''); }
      else { screen.removeAttribute('data-hj-suppress'); screen.removeAttribute('data-cs-mask'); }
      sec.classList.add('ht-still');
      if (painted) { enter(); keepInView(); }
      painted = true;
      wire(q, i);
    }
    function wire(q, i) {
      screen.querySelectorAll('.nw-ht-opt').forEach(function (b) { b.addEventListener('click', function () { choose(q, b.getAttribute('data-v'), b, i); }); });
      var nx = screen.querySelector('[data-nw-ht-next]');
      if (nx) nx.addEventListener('click', function () { track('quiz_step', { step_n: i + 1, step_id: q.key, total: visibleQs().length }); paint(i + 1); });
      var ot = screen.querySelector('[data-nw-ht-other]');
      if (ot) {
        ot.addEventListener('input', function () { S.answers[q.key + '_txt'] = ot.value.slice(0, 60); save(); });
        ot.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (nx && !nx.disabled) nx.click(); } });
      }
    }
    function choose(q, v, btn, i) {
      if (advancing) return;
      if (!S.started) { S.started = Date.now(); track('quiz_start', { variant: C.version }); publish('lit_quiz_started', {}); }
      var opt = null; q.options.forEach(function (o) { if (o.v === v) opt = o; });
      if (q.type === 'multi') {
        var arr = Array.isArray(S.answers[q.key]) ? S.answers[q.key].slice() : [];
        var pos = arr.indexOf(v);
        if (q.exclusive && v === q.exclusive) arr = pos > -1 ? [] : [v];
        else { arr = arr.filter(function (x) { return x !== q.exclusive; }); if (pos > -1) arr.splice(arr.indexOf(v), 1); else arr.push(v); }
        S.answers[q.key] = arr; save(); updateBarCta();
        screen.querySelectorAll('.nw-ht-opt').forEach(function (b) { var on = arr.indexOf(b.getAttribute('data-v')) > -1; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var nx = screen.querySelector('[data-nw-ht-next]'); if (nx) nx.disabled = !arr.length;
        var ow = screen.querySelector('.nw-ht-optwrap'), oi = ow && ow.querySelector('[data-nw-ht-other]');
        if (ow && oi && q.other) {
          var oon = arr.indexOf(q.other) > -1;
          ow.classList.toggle('is-on', oon); oi.hidden = !oon;
          if (oon && v === q.other) { try { oi.focus({ preventScroll: true }); } catch (e) { oi.focus(); } }
        }
        return;
      }
      S.answers[q.key] = v; save(); updateBarCta();
      screen.querySelectorAll('.nw-ht-opt').forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      track('quiz_step', { step_n: i + 1, step_id: q.key, total: visibleQs().length });
      var react = screen.querySelector('[data-react]'), wait = 300;
      if (opt && opt.r && react) { react.textContent = opt.r; react.classList.add('is-on'); wait = 900; }
      advancing = true;
      setTimeout(function () { advancing = false; paint(i + 1); }, reduced ? Math.min(wait, 400) : wait);
    }
    /* el ratón quieto sobre una respuesta recién pintada no la ilumina: solo al moverlo */
    sec.addEventListener('mousemove', function () { sec.classList.remove('ht-still'); }, { passive: true });
    backBtn.addEventListener('click', function () { track('quiz_back', { step_n: S.idx + 1 }); if (S.idx > 0) paint(S.idx - 1); });

    /* ---------- captura ---------- */
    function score() {
      var ax = { gasto: 0, agua: 0, senales: 0 };
      visibleQs().forEach(function (q) {
        var a = S.answers[q.key]; if (a === undefined || !ax.hasOwnProperty(q.axis)) return;
        var pts = 0; (Array.isArray(a) ? a : [a]).forEach(function (v) { q.options.forEach(function (o) { if (o.v === v) pts += (+o.p || 0); }); });
        if (q.max > 0) pts = Math.min(pts, q.max);
        ax[q.axis] += pts;
      });
      var t = C.thresholds || { radiador: 6, botijo: 3, agua: 2 };
      var perfil = ax.gasto >= t.radiador ? 'radiador' : (ax.agua >= t.agua && ax.gasto >= t.botijo) ? 'botijo' : (ax.agua < t.agua) ? 'cactus' : 'crucero';
      return { perfil: perfil, ejes: ax };
    }
    function paintCapture() {
      var list = visibleQs();
      progress(list.length, list.length);
      backBtn.hidden = false; S.idx = list.length; save();
      sec.classList.add('is-going', 'is-wide');
      screen.innerHTML = ''; screen.appendChild(capTpl.content.cloneNode(true));
      screen.setAttribute('data-hj-suppress', ''); screen.setAttribute('data-cs-mask', '');
      enter(); keepInView();
      /* los sobres de "Calculando", ya en caché cuando lleguen */
      (C.sachets || []).forEach(function (u) { if (u) { var im = new Image(); im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; } });
      track('quiz_capture_view');
      var form = screen.querySelector('[data-nw-ht-form]'), email = form.querySelector('[data-nw-ht-email]');
      var typo = form.querySelector('[data-nw-ht-typo]'), err = form.querySelector('[data-nw-ht-error]');
      email.addEventListener('blur', function () {
        var m = email.value.trim().toLowerCase().match(/^([^@\s]+)@([^@\s]+)$/); typo.hidden = true; if (!m) return;
        var best = null, bd = 3;
        DOMAINS.forEach(function (d) { var dd = lev(m[2], d); if (dd > 0 && dd < bd) { bd = dd; best = d; } });
        if (best) {
          var sug = m[1] + '@' + best;
          typo.innerHTML = esc(C.copy.typo || '¿Querías decir {s}?').replace('{s}', '<button type="button">' + esc(sug) + '</button>');
          typo.hidden = false;
          typo.querySelector('button').addEventListener('click', function () { email.value = sug; typo.hidden = true; email.focus(); });
        }
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = email.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(val)) { email.setAttribute('aria-invalid', 'true'); err.textContent = C.copy.emailError; err.hidden = false; email.focus(); return; }
        email.removeAttribute('aria-invalid'); err.hidden = true;
        finish(val, form.querySelector('[data-nw-ht-name]').value.trim(), form.querySelector('[data-nw-ht-optin]').checked, !!form.querySelector('[data-nw-ht-hp]').value);
      });
    }

    /* ---------- envío + resultado en la misma página ---------- */
    function utm() {
      var out = {};
      try { var p = new URLSearchParams(window.location.search); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (p.get(k)) out[k] = p.get(k); }); } catch (e) {}
      return out;
    }
    function payloads(email, name, optin, R) {
      var habits = {};
      visibleQs().forEach(function (q) { if (!q.local && q.prop && S.answers[q.key] !== undefined) habits[q.prop] = S.answers[q.key]; });
      var profileProps = Object.assign({ ht_perfil: R.perfil, ht_version: C.version, ht_completado_at: new Date().toISOString() }, habits);
      var evProps = Object.assign({}, profileProps, utm(), {
        perfil: R.perfil, optin_marketing: !!optin, consent_version: optin ? C.consentVersion : null, consent_text: optin ? C.consentText : null,
        quiz_version: C.version, landing: window.location.pathname, duration_s: S.started ? Math.round((Date.now() - S.started) / 1000) : null,
        is_test: /[?&]ht_test=1/.test(window.location.search)
      });
      var prof = { email: email }; if (name) prof.first_name = name;
      var sub = null;
      if (optin && C.list) sub = { data: { type: 'subscription', attributes: { custom_source: C.source, profile: { data: { type: 'profile', attributes: Object.assign({}, prof, { properties: profileProps, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }) } } }, relationships: { list: { data: { type: 'list', id: C.list } } } } };
      var ev = { data: { type: 'event', attributes: { properties: evProps, unique_id: S.uid, metric: { data: { type: 'metric', attributes: { name: C.metric } } }, profile: { data: { type: 'profile', attributes: Object.assign({}, prof, { properties: profileProps }) } } } } };
      return { sub: sub, ev: ev };
    }
    function post(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(C.company), {
        method: 'POST', keepalive: true, body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', revision: C.revision }
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
    }
    function finish(email, name, optin, isBot) {
      var R = score();
      var tooFast = S.started && (Date.now() - S.started) < (C.minSeconds || 10) * 1000;
      var result = { perfil: R.perfil, ejes: R.ejes, answers: S.answers, at: Date.now(), uid: S.uid };
      ss('lit_ht', result);
      var sent = Promise.resolve();
      if (C.send && !isBot && !tooFast) {
        var p = payloads(email, name, optin, R);
        ss('lit_ht_pending', { p: p, company: C.company, revision: C.revision });
        sent = Promise.race([
          (p.sub ? post('subscriptions', p.sub).catch(function () {}) : Promise.resolve()).then(function () { return post('events', p.ev); }).then(function () { ss('lit_ht_pending', null); }),
          new Promise(function (res) { setTimeout(res, 2500); })
        ]).catch(function () {});
        if (marketingOk() && window.klaviyo && typeof window.klaviyo.identify === 'function') { try { window.klaviyo.identify({ email: email }); } catch (e) {} }
      }
      track('quiz_complete', { perfil: R.perfil, optin: !!optin });
      track('generate_lead', { lead_source: 'test_hidratacion', perfil: R.perfil, optin: !!optin, event_id: S.uid });
      publish('lit_quiz_completed', { perfil: R.perfil, event_id: S.uid, optin: !!optin });
      countEl.textContent = ''; backBtn.hidden = true;
      screen.innerHTML = ''; screen.appendChild(calcTpl.content.cloneNode(true)); enter();
      sec.classList.add('is-going', 'is-wide'); keepInView();
      var fan = screen.querySelector('[data-nw-ht-calcfan]');
      (C.sachets || []).forEach(function (u) { if (!u) return; var im = new Image(); im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; im.alt = ''; fan.appendChild(im); });
      var txt = screen.querySelector('[data-nw-ht-calctext]'), msgs = (C.calc || []).filter(Boolean), mi = 0;
      if (msgs.length) { txt.textContent = msgs[0]; var rot = setInterval(function () { mi++; if (mi < msgs.length) txt.textContent = msgs[mi]; else clearInterval(rot); }, 520); }
      Promise.all([sent, new Promise(function (res) { setTimeout(res, reduced ? 600 : 1500); })]).then(function () {
        ss('lit_ht_draft', null);
        showBar(false);
        /* la sección de resultado (debajo) se pinta con esto; el test se oculta por CSS */
        try { document.dispatchEvent(new CustomEvent('nw:ht-result', { detail: result })); } catch (e) {}
      });
    }

    /* ---------- repetir el test (lo pide la sección de resultado) ---------- */
    document.addEventListener('nw:ht-restart', function () {
      S = { uid: 'ht-' + uuid(), answers: {}, idx: 0, started: 0 }; save();
      painted = false; paint(0); painted = true;
      window.scrollTo({ top: window.scrollY + sec.getBoundingClientRect().top, behavior: 'auto' });
    });

    /* ---------- teclado, como en Typeform: A-H elige, Enter = Siguiente ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      var r = sec.getBoundingClientRect(); if (r.bottom < 120 || r.top > window.innerHeight * 0.5 || !sec.offsetParent) return;
      var li = 'ABCDEFGH'.indexOf((e.key || '').toUpperCase()), optsEls = screen.querySelectorAll('.nw-ht-opt');
      if (e.key && e.key.length === 1 && li > -1 && li < optsEls.length) { e.preventDefault(); optsEls[li].click(); return; }
      if (e.key === 'Enter') { var nx = screen.querySelector('[data-nw-ht-next]:not([disabled])'); if (nx) { e.preventDefault(); nx.click(); } }
    });

    /* ---------- vista ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !viewed) { viewed = true; track('quiz_view', { variant: C.version }); } }); }, { threshold: 0.3 });
      io.observe(sec);
    }

    /* ---------- barra fija: solo si se baja sin terminar ---------- */
    var bar = sec.querySelector('[data-nw-ht-bar]');
    document.body.appendChild(bar);
    var barShown = null;
    function showBar(v) { if (v === barShown) return; barShown = v; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); var b = bar.querySelector('a'); if (b) b.tabIndex = v ? 0 : -1; }
    function updateBarCta() { var cta = bar.querySelector('[data-nw-ht-barcta]'); if (cta) cta.textContent = Object.keys(S.answers).length ? cta.getAttribute('data-resume') : cta.getAttribute('data-start'); }
    function fbUpdate() {
      if (document.documentElement.classList.contains('ht-has-result') || !sec.offsetParent) return showBar(false);
      showBar(sec.getBoundingClientRect().bottom < window.innerHeight * 0.35);
    }
    var fbTick = false;
    window.addEventListener('scroll', function () { if (!fbTick) { fbTick = true; requestAnimationFrame(function () { fbTick = false; fbUpdate(); }); } }, { passive: true });
    window.addEventListener('resize', fbUpdate, { passive: true });
    bar.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: window.scrollY + sec.getBoundingClientRect().top, behavior: reduced ? 'auto' : 'smooth' }); });
    updateBarCta(); fbUpdate();

    /* ---------- arranque: P1 del servidor, o donde se quedó ---------- */
    if (S.idx > 0 && Object.keys(S.answers).length) { paint(S.idx, { resume: true }); }
    else { S = { uid: 'ht-' + uuid(), answers: {}, idx: 0, started: 0 }; save(); updateBarCta(); paint(0); }  /* sin borrador a medias: se empieza de cero */
  }

  function wireSachets() {
    /* los sobres por sabor de "Solo lo esencial" se precargan al acercarse: la rotación cada 2 s no espera a la red */
    if ('IntersectionObserver' in window) {
      document.querySelectorAll('.nw-esencial').forEach(function (s) {
        var t = s.querySelector('[data-nw-esencial-flavors]');
        if (!t || s.__nwPre) return;
        s.__nwPre = true;
        var pio = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          pio.disconnect();
          try { var m = JSON.parse(t.textContent); Object.keys(m).forEach(function (k) { if (m[k] && m[k].src) { var im = new Image(); im.src = m[k].src; } }); } catch (e) {}
        }, { rootMargin: '900px 0px' });
        pio.observe(s);
      });
    }
  }   /* sin animación de los sobres (Juan, ronda 7): ni el trío del test ni los de "Solo lo esencial" se mueven */

  /* ---------- "Solo lo esencial": Lemon -> Peach -> Watermelon cada 3 s con fundido cruzado de 1,4 s ----------
     La imagen base (Lemon) no se toca: encima van Peach y Watermelon con el mismo encuadre (clones) y se funden.
     Se pausa con el cursor sobre los sobres; se para del todo si el usuario elige sabor en la ficha (nw:flavor tras
     el resultado: la propia sección cambia entonces la imagen base). Sin rotación con reduced-motion. */
  function crossfadeEsencial() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.nw-esencial').forEach(function (sec) {
      if (sec.__nwX) return;
      var base = sec.querySelector('[data-nw-esencial-img]'), tag = sec.querySelector('[data-nw-esencial-flavors]');
      if (!base || !tag) return;
      var map; try { map = JSON.parse(tag.textContent || '{}'); } catch (e) { return; }
      var media = base.parentNode, layers = [];
      ['lit-daily-hydration-peach', 'lit-daily-hydration-watermelon'].forEach(function (h) {
        var f = map[h]; if (!f || !f.src) return;
        var im = base.cloneNode(false);
        im.removeAttribute('data-nw-esencial-img'); im.removeAttribute('data-nw-layer');
        im.src = f.src; im.alt = ''; im.setAttribute('aria-hidden', 'true'); im.classList.add('nw-ht-xfade');
        media.appendChild(im); layers.push(im);
      });
      if (!layers.length) return;
      sec.__nwX = true;
      var sync = function () { layers.forEach(function (l) { l.style.transform = base.style.transform; }); };
      new MutationObserver(sync).observe(base, { attributes: true, attributeFilter: ['style'] }); sync();
      var i = 0, hovered = false, stopped = false, timer = null, later = null;
      function show(k) {
        clearTimeout(later);
        if (k === 0) { layers.forEach(function (l) { l.classList.remove('is-on'); }); return; }
        var top = layers[k - 1]; top.classList.add('is-on');
        later = setTimeout(function () { layers.forEach(function (l) { if (l !== top) l.classList.remove('is-on'); }); }, 1500);
      }
      function step() { if (hovered || stopped) return; i = (i + 1) % (layers.length + 1); show(i); }
      media.addEventListener('mouseenter', function () { hovered = true; });
      media.addEventListener('mouseleave', function () { hovered = false; });
      document.addEventListener('nw:flavor', function () {
        if (!document.documentElement.classList.contains('ht-has-result')) return;
        stopped = true; show(0); if (timer) { clearInterval(timer); timer = null; }
      });
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !timer && !stopped) timer = setInterval(step, 3000);
          if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.3 }).observe(sec);
    });
  }

  function boot() { document.querySelectorAll('[data-nw-ht]').forEach(init); wireSachets(); crossfadeEsencial(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-test-resultado"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwHtrInit) return;
  window.__nwHtrInit = true;
  function ss(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function analyticsOk() { var p = window.Shopify && Shopify.customerPrivacy; try { return !p || typeof p.analyticsProcessingAllowed !== 'function' || p.analyticsProcessingAllowed(); } catch (e) { return false; } }
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var html = document.documentElement;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function onShown(st, key) {
      if (analyticsOk()) try { (window.dataLayer = window.dataLayer || []).push({ event: 'typ_view', typ_state: st, perfil: key }); } catch (e) {}
      if (st === 'a' || st === 'b') {
        /* atribución: el pedido lleva el origen y el perfil aunque se pierda la query string */
        var attrs = { _origen: 'test-hidratacion', _perfil_test: key };
        try { var q = new URLSearchParams(location.search); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (q.get(k)) attrs['_' + k] = q.get(k); }); } catch (e) {}
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
      }
    }
    var st0 = sec.getAttribute('data-ht-state');
    if (st0 !== 'none') onShown(st0, sec.getAttribute('data-ht-perfil'));

    /* el test acaba de terminar en esta misma página */
    document.addEventListener('nw:ht-result', function (e) {
      var r = e.detail || {}; if (!r.perfil) return;
      sec.setAttribute('data-ht-state', 'a'); sec.setAttribute('data-ht-perfil', r.perfil);
      html.classList.remove('ht-no-offer'); html.classList.add('ht-has-result');
      if (typeof sec.__htrFill === 'function') sec.__htrFill(r.perfil, r);
      requestAnimationFrame(function () { window.scrollTo({ top: window.scrollY + sec.getBoundingClientRect().top, behavior: 'auto' }); });
      onShown('a', r.perfil);
    });
    /* repetir el test */
    sec.querySelectorAll('[data-htr-restart]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        try { sessionStorage.removeItem('lit_ht'); } catch (e) {}
        html.classList.remove('ht-has-result', 'ht-no-offer'); sec.setAttribute('data-ht-state', 'none');
        try { document.dispatchEvent(new CustomEvent('nw:ht-restart')); } catch (e) {}
      });
    });
    /* reintento único del envío a Klaviyo que la navegación pudo cortar */
    var pend = ss('lit_ht_pending');
    if (pend && pend.p && pend.company) {
      try { sessionStorage.removeItem('lit_ht_pending'); } catch (e) {}
      var post = function (path, body) { return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(pend.company), { method: 'POST', keepalive: true, body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', revision: pend.revision } }); };
      (pend.p.sub ? post('subscriptions', pend.p.sub).catch(function () {}) : Promise.resolve()).then(function () { return post('events', pend.p.ev); }).catch(function () {});
    }
    /* compartir */
    var share = sec.querySelector('[data-htr-share]');
    if (share) share.addEventListener('click', function () {
      var C = {}; try { C = JSON.parse(sec.querySelector('[data-nw-htr-config]').textContent); } catch (e) {}
      var key = sec.getAttribute('data-ht-perfil') || '', P = (C.profiles || {})[key] || {};
      var u = location.origin + location.pathname + '?p=' + encodeURIComponent(key) + '&utm_source=share&utm_medium=referral&utm_campaign=ht_share';
      if (navigator.share) { navigator.share({ text: P.share || '', url: u }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText((P.share || '') + ' ' + u).then(function () { var t = share.textContent; share.textContent = 'Enlace copiado'; setTimeout(function () { share.textContent = t; }, 1800); }).catch(function () {});
    });
  }
  function boot() { document.querySelectorAll('[data-nw-htr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-texto-imagen"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwTiInit) return;
  window.__nwTiInit = true;
  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-ti[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nwTimelineInit) return;
  window.__nwTimelineInit = true;

  // Dibuja una serpentina suave (Catmull-Rom) que pasa EXACTAMENTE por los 3 puntos.
  function drawPath(sec) {
    var svg = sec.querySelector('.nw-timeline__mpath');
    var curve = sec.querySelector('.nw-timeline__mcurve');
    var card = sec.querySelector('.nw-timeline__card');
    if (!svg || !curve || !card) return;
    if (getComputedStyle(svg).display === 'none') return; // solo móvil
    var cr = card.getBoundingClientRect();
    if (!cr.width || !cr.height) return;
    var dots = Array.prototype.slice.call(sec.querySelectorAll('[data-nw-mdot]'));
    if (dots.length < 2) return;
    /* viewBox en PÍXELES REALES del card => escala 1:1 uniforme (sin la distorsión de
       viewBox 0-100 + preserveAspectRatio none, que deformaba los controles del spline). */
    svg.setAttribute('viewBox', '0 0 ' + cr.width.toFixed(1) + ' ' + cr.height.toFixed(1));
    var pts = dots.map(function (d) {
      var r = d.getBoundingClientRect();
      return { x: (r.left + r.width / 2) - cr.left, y: (r.top + r.height / 2) - cr.top };
    });
    var first = pts[0], last = pts[pts.length - 1];
    /* La serpentina llega hasta los EXTREMOS del card (borde superior e inferior),
       igual que en desktop; se empuja un poco hacia el lado del primer/último punto
       para que el trazo alcance las esquinas. */
    var P = [{ x: Math.min(cr.width, first.x + 34), y: 0 }]
      .concat(pts)
      .concat([{ x: Math.min(cr.width, last.x + 34), y: cr.height }]);
    var d = 'M ' + P[0].x.toFixed(1) + ' ' + P[0].y.toFixed(1);
    for (var i = 0; i < P.length - 1; i++) {
      var p0 = P[i - 1] || P[i], p1 = P[i], p2 = P[i + 1], p3 = P[i + 2] || p2;
      var c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
      var c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
      d += ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ' ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1);
    }
    curve.setAttribute('d', d);
  }

  function init(sec) {
    if (!sec || sec.dataset.nwReady) return;
    sec.dataset.nwReady = '1';
    var draw = function () { drawPath(sec); };
    draw();
    setTimeout(draw, 250); setTimeout(draw, 700);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
    window.addEventListener('resize', function () { clearTimeout(sec._nwt); sec._nwt = setTimeout(draw, 150); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); draw(); io.unobserve(sec); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else { sec.classList.add('is-in'); }
  }
  function boot() { document.querySelectorAll('.nw-timeline[data-nw-reveal-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ssc-about');
    if (!sections.length || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.ssc-about .reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: .12 });
    sections.forEach(function (sec) {
      sec.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    });
  })();

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-about');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playVideo(slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pauseVideo(slide) {
      var v = slide.querySelector('video');
      if (v) v.pause();
    }
    function init(el) {
      var slides = el.querySelectorAll('.ssc-hero__bg');
      var dots = el.querySelectorAll('[data-ssc-dot]');
      if (!slides.length) return;

      // Kick off the first slide's video (browsers normally autoplay muted videos,
      // but we call play() explicitly to cover edge cases).
      playVideo(slides[0]);

      if (slides.length <= 1) return;

      var idx = 0;
      var timer;
      function go(i) {
        pauseVideo(slides[idx]);
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        playVideo(slides[idx]);
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === idx);
          if (n === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function start() { stop(); timer = setInterval(function () { go(idx + 1); }, 4200); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-ssc-dot'), 10));
          start();
        });
      });
      start();
    }
    document.querySelectorAll('[data-ssc-hero]').forEach(init);
  })();

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-hero');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-instagram"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-ig');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-next-event"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-event');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-past"] && !Shopify.designMode) return;
  try {
    
  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-past');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-upcoming"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-sched');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();
})();
